// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../resources/fonts/MarkBook.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../resources/fonts/MarkBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../resources/images/welcome_bgd.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../resources/images/mock-up.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../resources/images/orbiwise-white-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` html {
    height: 100vh;
}  
body {
    font-family: "MarkBook", sans-serif !important;
    background-color: #EBF3F1;
    font-family: proxima-nova, sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 0.95rem;
   /* height: calc(100vh - 81px);*/

   overflow: hidden;

}
@media screen and (min-width: 1681px){
    .container, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl {
      max-width: 1520px !important;  
     
    }
    }
     

@media screen and (max-width: 1680px) {
.container, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl {
  max-width: 1520px;  
  max-width: calc(100vw - 0px);
padding: 0px !important;
}
}

:root {
    --navbar-fg-color: white;
    --navbar-bg-color: var(--bs-body-color);
    --tab-height-default: calc(100vh - 180px);
    --tab-height-impersonated: calc(100vh - 220px);
}

 
*:focus {
    outline: none;
}
  .btn:focus, .btn.focus {
    outline: none !important;
   
}

 #root{
    height:  100%;
}

.ob-wrapper {
    /*  height: calc(100vh - 81px);*/
    height:  auto;
}

.ow-nst-wrapper {
  /*  height: calc(100vh - 81px);*/
    height:  auto;
}
/*
.ow-nst-wrapper .desktop-menu .top_header_desktop,
.ow-nst-wrapper .desktop-menu .main_header_desktop{
    background-color: #757575 !important;
}*/

.desktop-menu {
    background-color: var(--navbar-bg-color);
}

.mobile-menu {
    background-color: var(--navbar-bg-color);
}


.wrapper {
    height:  100%;   
} 

.table-wrapper {
    height: calc(100vh - 120px);
    width:100%;
    padding-top: 10px;
}

.impersonated{
    height: calc(100vh - 170px) !important;
}

.batch-registraion-wrapper {
    height: calc(100vh - 340px);
    width:100%;
    padding-top: 10px;
}

.child-table-wrapper {
   height: calc(100vh - 110px) !important;
   width:100%;
   padding-top: 10px;
   
}

.child-table-wrapper-impersonated {
    height: calc(100vh - 110px) !important;
    width:100%;
    padding-top: 10px;
    
}

.aggrid-child-table{
    height: 100% !important;
    display: flex;
    flex-direction: column;
    font-size: 12px;
}

.aggrid-child-table-impersonated{
    height: calc(100% - 50px) !important;
    display: flex;
    flex-direction: column;
    font-size: 12px;
}

.child-tab-wrapper {
    max-height: calc(100vh - 20px) !important;
    width:100%;
    padding-top: 10px;
 }

 .child-tab-wrapper-impersonated {
    min-height: calc(100vh - 130px) !important;
    width:100%;
    padding-top: 10px;
 }

.ow-data-table-container {
  /*  height: calc(100vh - 250px) !important;
    height: fit-content !important;
    height: calc(100vh - 220px) !important;
    height: calc(100vh - 180px) !important;*/
    min-height: calc(100vh - 210px) !important;
    min-height: calc(100dvh - 210px) !important;
    min-height: calc(100svh - 210px) !important;
 /* margin-top: 15px;
overflow-x: hidden !important;*/
}
.ow-data-table-container-impersonated {
    height: calc(100vh - 220px) !important;
}

.view-data .ow-data-table-container-impersonated {
    height: calc(100vh - 250px) !important;
}

#ow-data-table-container-batch-registration {
    height: calc(100vh - 200px) !important;
}
.table-wrapper-map {
    height: calc(100vh - 150px);
    height: calc(100svh - 150px);
    height: calc(100dvh - 150px);
    width:100%;
}
#map-container-div {
    width: 100%;
    height: 100% !important;
}

@font-face {
    font-family: "MarkBook";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    
}
@font-face {
    font-family: "MarkBold";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    
}

.h1, .h2, .h3, h1, h2, h3 {
/*
    margin-top: 20px;
    margin-bottom: 10px;
*/
    vertical-align: middle !important;
}

h1 {
    font-size: 1.8em;
    font-weight: bold;
    margin-top: 0.8em; /* Reduced margin */
    margin-bottom: 0.4em; /* Reduced margin */
    color: #333;
}

h2 {
    font-size: 1.5em;
    font-weight: bold;
    margin-top: 0.7em; /* Reduced margin */
    margin-bottom: 0.3em; /* Reduced margin */
    color: #444;
}

h3 {
    font-size: 1.2em;
    font-weight: bold;
    margin-top: 0.6em; /* Reduced margin */
    margin-bottom: 0.3em; /* Reduced margin */
    color: #555;
}

h4 {
    font-size: 1em;
    font-weight: bold;
    margin-top: 0.5em; /* Reduced margin */
    margin-bottom: 0.2em; /* Reduced margin */
    color: #666;
}

h5, h6 {
    font-size: 0.9em;
    font-weight: bold;
    margin-top: 0.4em; /* Reduced margin */
    margin-bottom: 0.2em; /* Reduced margin */
    color: #777;
}

/* Optional: Add consistent spacing for all headers */
h1, h2, h3, h4, h5, h6 {
    line-height: 1.2; /* Maintain readability */
}





*:focus {outline:none !important}

.img-left-logo {
    min-width: 30px;
    max-height: 30px;
    margin-top: 5px;
    margin-bottom: 5px;   
    padding-right: 15px;

}

.badge{
    font-size: 0.8rem;
    font-weight: normal;
    margin:2px ;  
   background-color: #fbfbfb;
    border: 1px solid #878686;
    color: #3a3a3a; 
    border-radius: .2rem !important;
}
.badge.bg-dark{
    color: #fff;
    font-size: 0.75em;
}

.badge.blue{
    color: #076d9f;
    background: #D0F6FF 0% 0% no-repeat padding-box;
    border: 1px solid #A3E7FF;
    text-align: left;
}
.badge.blue a{
    color: #076d9f;}
    
.wrapper {
    margin: 0px 4px;
 /*   padding-top: 10px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 2px 10px #0000001A;
   
    border-radius: 4px;*/
}

.shadow {
    box-shadow: 0 .2rem 0.3rem rgba(0, 0, 0, 0.38) !important;
  }
.has-error > .css-1s2u09g-control{
    border-color: #dc3545 !important;
} 
.form-control:disabled, .form-control[readonly] {
  
    cursor: not-allowed;
  }

.css-1insrsq-control {
    border: 1px solid #ced4da !important;
    background-color: #e9ecef !important;
    opacity: 1;
    cursor: not-allowed !important;
}
.css-3iigni-container{

    cursor: not-allowed !important;
}

.css-3iigni-container .css-16xfy0z-control{
    background-color: #e9ecef;
    border: 1px solid #ced4da;
}
.css-3iigni-container .css-16xfy0z-control  .css-3w2yfm-ValueContainer .css-1p3m7a8-multiValue {
    background-color: #aaa;
}

.form-control::-moz-placeholder{
    color:#d4d4d4 !important; 
}

#operationalStatusSelect::placeholder{
    color:#d4d4d4 !important; 
}

.invalid-tooltip {
    right: 1%;
    margin-top: -10.1rem;
    display: inline-block !important;
    position: initial;
}
.css-1insrsq-control .css-1hwfws3 .css-1rhbuit-multiValue{
    background-color: rgb(187, 187, 187);
    height:30px !important
}

.dropdown .dropdown-menu{
    box-shadow:0 .1rem 0.3rem rgba(0, 0, 0, 0.2) !important;
}
/* ---- style for react-datepicker ---- */
.react-datepicker-wrapper .react-datepicker__input-container input{
    display: block;
    width: 100%;
    min-height: calc(1.5em +   2px);
    padding: .57rem .5rem;
    font-size: .875rem; 
    font-weight: 400;
    line-height: 1;
    color: #212529;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: .25rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

.react-datepicker-popper[data-placement^="bottom"] {
    padding-top: 8px;

}
.data-table-custom .react-datepicker-wrapper .react-datepicker__input-container input{

    padding: .35rem .5rem;
}
.mr-1{
    margin-right: 5px;
}
.mr-2{
    margin-right: 10px;
}
.nav-wrapper {
    margin-bottom: 80px !important;
}
.mar-120 {
    margin-bottom: 120px !important;
}

.mar-120-mobile {
    margin-bottom: 0px !important;
    margin-top: 150px !important;
}

.mar-top-120 {
    margin-top: 150px !important;
}

.content-wrapper {
    padding-top: 20px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
}

.navbar {
    margin-bottom: 0;
    border-radius: 0;
    padding: 0px;
} 
.navbar-toggler{
    border: 0px;}


    .navbar-toggler:focus {
        outline: none;
        box-shadow: none;
      }
.top_header_desktop, .main_header_desktop, .container-fluid{
    min-height: 40px!important;
    border: none;
    padding: 0%;
}
 .top_bar_name_instance_holder {
    padding-top: 10px;
    padding-bottom: 10px;
    display: inline-block; 
}


.top_bar_name_instance_holder .instance_holder,
.top_bar_name_instance_holder .app_name_holder {
  /*  padding-left: 15px; */
    font-size: 14px;
    font-weight: normal !important;
    display: inline-block;
    color: var(--navbar-fg-color);
}
.top_bar_name_instance_holder .separator_holder {
    margin: 0px 10px;
    color: white; 
    line-height: initial;
}
 
.instance_holder {
    color: var(--navbar-fg-color);
}
.top_header_desktop .top_bar_name_instance_holder > div:first-of-type {
    padding-left: 0px;
}

.navbar .navbar-nav .nav-item .nav-link {
    font-size: 14px;  
    font-size: 1rem;
    line-height: 22px;
}

#navbar-root .main_header_desktop {
   /* box-shadow: 0px 4px 4px rgb(0 0 0 / 25%); */
    width: 100%;
}

#navbar-root nav.main_header_desktop  .navbar-nav  .nav-item  a.nav-link:not(.show),
#navbar-root nav.main_header_desktop .navbar-nav .nav-link a {
    color: var(--navbar-fg-color) !important;
    text-decoration: none;
}

#navbar-root .main_header_desktop  .navbar-nav  .nav-item  .nav-link:hover::before {
    border-bottom: 5px solid #ffffff !important;
    color: #fff;
    content: "";
   /* position: sticky; */
    bottom: 0;
    width: 100%;
    left: 0;
}



#navbar-root nav.main_header_desktop .navbar-nav .nav-item.active_menu_dropdown a.nav-link{
    padding-bottom: 5px;
    border-bottom: 5px solid #eceef0  !important;
}


#navbar-root nav.main_header_desktop  .navbar-nav  .nav-item:focus  a.nav-link {
    border-bottom: 5px solid #eceef0  !important;
}

#navbar-root nav.main_header_desktop .main_header_desktop > .show > a, 
#navbar-root nav.main_header_desktop .main_header_desktop > .show > .dropdown-menu {
    background-color: #fff;
    border: none;
    border-radius: 0px;
    -webkit-box-shadow: 0 6px 12px rgb(0 0 0 / 18%);
    margin-top: 0px;
    box-shadow: 0 6px 12px rgb(0 0 0 / 18%);
}
#navbar-root nav.main_header_desktop .main_header_desktop > .show > .dropdown-menu  a {
    display: block;
    padding: 3px 20px 3px 0px;
    clear: both;
    font-weight: 400;
    line-height: 1.42857143; 
    font-size: 0.95rem;
    color: #333 !important;
}

#navbar-root nav.main_header_desktop .main_header_desktop > .show > .dropdown-menu  .dropdown-item:hover,
#navbar-root nav.main_header_desktop .main_header_desktop > .show > .dropdown-menu  .dropdown-item.active,
#navbar-root nav.main_header_desktop .main_header_desktop > .show > .dropdown-menu  .dropdown-item:active {
    background-color: #e9e9e9;
}


#navbar-root nav.main_header_desktop .main_header_desktop > .show > .dropdown-menu  .dropdown-item:focus{ 
    background-color: #e9e9e9;
}

.active_menu_item > a::before {
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 5px solid #d55151;
    content: '';
    position: absolute;
    left: 0;
    margin-top: 5px;
    
}


.schema-engine-active-menu  > a::after{
    content: "";
    display: block;
    margin: auto;
    height: 5px;
    position: relative;
    width: 0;
    top: 5px;
    background: transparent;
    transition: all 0.5s;
}  

 .schema-engine-active-menu  > a:hover::after,
 .schema-engine-active-menu a::after {
    width: 100%;
    background: #fff;
  }
  
 .schema-engine-active-menu-dropdown-item:hover,
 .schema-engine-active-menu-dropdown-item {
    background-color: #e9e9e9 !important;
 } 

a.active_menu_item {
    font-weight: bold!important;
}
.active_menu_dropdown.show {
    box-shadow: inset -5px 11px 6px -8px #16243454 !important;
    background-color: #eceef0;
}

#navbar-root nav.top_header_desktop .top_header > .show > a,
 #navbar-root nav.main_header_desktop .main_header_desktop > .show > a {
    box-shadow: inset -5px 11px 6px -8px #16243454 !important;
    color: #333 !important;
   /* margin-top: 3px;*/
}


.img-left-logo {
    min-width: 30px;
    max-height: 30px;
    margin-top: 5px;
    margin-bottom: 5px;

}
.img-right-logo, .img-right-logo> a {
    min-width: 45px;
    max-height: 40px;
    display: inline-block;
    padding-top: 5px;
}
.img-right-logo-img{
    min-width: 30px;
    max-height: 30px;
}
.img-left-logo-img {
    min-width: 30px;
    max-height: 30px;
}
.user_icon {
    min-width: 20px;
    max-height: 20px;
    padding-right: 5px;
}
.user_icon.forward_login_icon {
    min-width: 15px;
    max-height: 15px;
}
/* DESKTOP MEDIA QUERY */
@media (min-width: 1200px) {
    .top_header_desktop,
    .main_header_desktop{
        min-height: 40px !important;
        height: 40px !important
    }
    #navbar-root + * {
        padding-top: 81px;
    }
}
.sign-in {  
    font-weight: normal;
    color: white !important;
    padding: 10px 15px;
    line-height: 20px;
    text-decoration: none;
}

#navbar-root {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1012 !important;  
    box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
}

.ow-position-fixed{
    position: fixed;
height: 60px;
top: 80px;
z-index: 1010;
display: block;
margin-bottom: 84px;
left: 4px;
right: 4px;
background-color: #fff;
}

/* DESKTOP MEDIA QUERY */
@media (min-width: 1200px) {
    #navbar-root + * {
        padding-top: 81px;
    }
}
/* TABLET MEDIA QUERY */
@media (min-width: 768px) and (max-width: 1199px) {
    #navbar-root + * {
        padding-top: 87px;
    }
}
/* MOBILE MEDIA QUERY */
@media (max-width: 767px) {
    #navbar-root + * {
        padding-top:80px;
    }
    #navbar-root nav.main_header_desktop  .navbar-nav  .nav-item.active_menu_dropdown  a.nav-link:before,
    #navbar-root nav.main_header_desktop  .navbar-nav  .nav-item.active_menu_dropdown  a.nav-link:hover {
        border-bottom: 0px  !important;
    }
    .navbar-nav .nav-link {
        padding-left: 10px;
    }
    #navbar-root nav.main_header_desktop .navbar-nav .nav-item a.nav-link:hover {
        border-bottom: 0px  !important;
        background-color: #cccccc57;
    } 
    #navbar-root nav.main_header_desktop .navbar-nav .active_menu_dropdown.nav-item a.nav-link {
        background-color: #cccccc57;
    }
    .top_bar_name_instance_holder{  padding-top: 5px;}     
    .top_bar_name_instance_holder .instance_holder, 
    .top_bar_name_instance_holder .app_name_holder {
        font-size: 12px;
    }
    .img-left-logo {
        min-width: 30px;
        max-height: 20px;
        margin-top: 10px;
        margin-bottom: 0px;
      }
      .table-wrapper { 
        padding-top: 0px;
      }
      .wrapper {
        padding-top: 0px !important;
      }
      .breadcrumb{
        padding:5px  0px !important;
      }
      .nav-wrapper{
        margin-bottom: 60px !important;
      }
      .mar-120{
        margin-bottom: 130px !important;
      }
      .mar-120-mobile {
        margin-bottom: 0px !important;
        margin-top: 120px !important;
       }
       

}

/****START WELCOME PAGE****/
.welcomePage{
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-position: center;
    background-repeat: no-repeat;
    vertical-align: -webkit-baseline-middle;
    background-size: cover;
    height: 400px;
    -webkit-box-shadow: -11px 13px 20px -6px rgba(0,0,0,0.15);
    -moz-box-shadow: -11px 13px 20px -6px rgba(0,0,0,0.15);
    box-shadow: -11px 13px 20px -6px rgba(0,0,0,0.15);
    text-align: center;
    margin-right: auto;
    margin-left: auto;
   /* margin-top: calc(50vh - 245px);*/
    
    margin-top: 200px;
}
.welcomePageCenter{
    height: 400px;
    display: table;
    margin: 0 auto;
}

.welcomePageRight {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    height: 210px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
}
.m-t-20 {
    margin-top: 20px;
    height: calc(100vh - 70px);
}

.welcomePageTitle{
    color: #ce0008;
    font-size:44px;
    font-family: "MarkBold", sans-serif;
}
.welcomeRightMessage{
    text-align: center;
    bottom: 42px;
    position: relative;
    margin-left: 45px;
}
.welcomePageMessage{
    color: #10171e;
    font-size: 20px;
    margin-bottom: 18px;
}
.welcomePageButtonLearn{
    border: 1px solid #ce0008;
    border-radius: 0px;
    color:#ce0008;
    background: transparent;
}
.welcomePageButtonLearn:hover{
    color: #10171e;
    background: #fff;
    border:1px solid #ce0008;
}
.btn-icon{
    width: 30px;
height: 30px;
vertical-align: middle;
text-align: center;
display: inline;  
padding: .25rem .25rem !important;
}
.btn-area {
    margin: 0;
    padding: 0 15px;
}
.btn_sign_up {
    color: #0f1f2e;
    height: 35px;
  /*  font-size: 16px; */
    background: #fff;
    border: 1px solid #0f1f2e;
    margin-bottom: 17px;
}
.btn_sign_up:hover {
    color: #fff;
    border: 1px solid #0f1f2e;
    background: #0f1f2e;
}
.btn_sign_up:focus{
    outline: 0;
}
/* .btn-ch a[disabled=disabled] {
 color: red;
 font-weight: bold;
 } */
.welcomePageButtonSingUp{
    border: 1px solid #ce0008;
    border-radius: 0px;
    color: white;
    background-color: #ce0008;
}
.welcomePageButtonSingUp:hover{
    color: #10171e;
}
.welcomePageContent{
    vertical-align: middle;
    display: table-cell;
    height: 400px;
}
.welcomePageContent img{
    margin: 0px auto;
}

.text_center_style {
    font-size: 16px;
    text-align: center;
}
.text_under_mc{
    font-size: 24px;
    color:#ce0309;
    text-align: center;
}
.display_inl {
    display: inline;
}
.welcomePowerBy{
    position: absolute;
    right: 10px;
    bottom: 8px;
    text-align: right
}

@media (max-width: 767px) {
    .welcomePage{
        height: 650px; 
        margin-top: 60px;
    }
    .welcomePageContent{
        height: 250px;
    }
}
/****END WELCOME PAGE****/

/* Login page start */
.login-wrapper  img {
    max-width: 100%;
}
.img_padding_bottom {
    padding-bottom: 10px;
}
.background-login{
	background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
	 background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    height: calc(100vh - 80px);
    /* height: 100%; */
    display: table;
    table-layout: fixed;
    width: 100%;
    overflow: hidden;
}
.login-wrapper {
    margin-top: 4rem;
}
.a-link {
    color: #172434;
    text-decoration: underline;
    font-size: 12px;
}

/* Login page end */
#user_dropdown_item {
    margin-right: 5px;
    font-weight: normal !important;
}
.shadow_dropdown .dropdown-toggle::after {
    vertical-align: .055em;
}
.shadow_dropdown>a:hover,
.shadow_dropdown > .nav-link {
    color: var(--navbar-fg-color) !important;
}
.shadow_dropdown.show {
    background-color: white!important;
    box-shadow: inset -5px 11px 6px -8px #16243454 !important;
    color: #333 !important;
}
.shadow_dropdown.show > .nav-link {
    color: #333 !important;
}

.shadow_dropdown>a[aria-expanded="true"]:hover {
    color: black!important;
}
.shadow_dropdown .dropdown-menu{
    margin-top: 0px;
    border-radius:0px;
    padding: 0;
}
.navbar-expand .navbar-nav .dropdown-menu{
    min-width: 200px;
}

.navbar-expand .navbar-nav .shadow_dropdown .dropdown-menu.show .dropdown-item:hover{
    background-color: #ccc !important;
}
.user_icon {
    min-width: 20px;
    max-height: 20px;
    padding-right: 5px;
}
.img_user {
    min-width: 40px;
    max-height: 40px;
    margin-right: 5px;
}
a[aria-expanded="true"] span img[id="user_icon2"] {
    filter: invert(85%);
}
#navbar-root .top_header_desktop .top_header .width_mobile > .dropdown-menu > .dropdown-item {
    font-size: 0.95rem;
    line-height: 1.42857143;
    vertical-align: middle;
    font-weight: 400;
    display: table;
/*    border-top: 1px solid #ccc;   TODO: why is this here?? */
    padding: .3rem 1rem;
    color: #000;
}


#navbar-root .top_header_desktop .top_header .width_mobile > .dropdown-menu > .dropdown-item > svg {
    padding-right: 10px;
    padding-top: 4px;
}

#navbar-root .top_header_desktop .top_header .width_mobile > .dropdown-menu > .dropdown-item  svg{    
    font-size:1.2rem;
    width: 25px;
    color: #000;
}

#navbar-root .top_header_desktop .top_header .width_mobile > .dropdown-menu > .dropdown-item.active,
#navbar-root .top_header_desktop .top_header .width_mobile > .dropdown-menu > .dropdown-item:active,
#navbar-root .top_header_desktop .top_header .width_mobile > .dropdown-menu > .dropdown-item:focus {
    background-color: #e9e9e9 !important;
}


.lang_dropdown > .dropdown-menu > .dropdown-item > svg {
    color: #000;
}

.lang_dropdown > .dropdown-menu > .dropdown-item.active,
.lang_dropdown > .dropdown-menu > .dropdown-item:focus {
    background-color: #e9e9e9 !important;
    color: #000 !important;
}


#navbar-root .top_header_desktop .top_header .width_mobile > .dropdown-menu > .dropdown-item:active svg,
#navbar-root .top_header_desktop .top_header .width_mobile > .dropdown-menu > .dropdown-item:focus svg,
#navbar-root .top_header_desktop .top_header .width_mobile > .dropdown-menu > .dropdown-item.active svg{
    color: black;
}


/* ------------------------------------------------------------------------------- *
 *- Schema Modal styles ----------------------------------------------------------- *
 * ------------------------------------------------------------------------------- */

 .schema-engine-error-text{
    color: #dc3545 !important;
} 
.schema-engine-error-frame{
    border-color: #dc3545 !important;
} 


 .schema-engine-header{
    background-color: transparent;
    color: #000;
    border-bottom: none;
    border-top-left-radius:0;
border-top-right-radius: 0;
}

.schema-engine-footer{

    border-top: none;
    border-bottom-left-radius:0;
border-bottom-right-radius: 0;
}

.schema-engine-body{
    /*padding: 0px;*/
} 
.schema-engine-tabs{

}
.schema-engine-tabs .schema-tab-list {
    height: var(--tab-height-default);
    overflow-y: scroll;
    flex-wrap: nowrap;
  }
  
  .child-tab-wrapper-impersonated .schema-engine-tabs .schema-tab-list {
    height: var(--tab-height-impersonated);
    overflow-y: scroll;
    flex-wrap: nowrap;
  }

.schema-engine-tabs .schema-tab-list .nav-link{
    word-break: break-all;
}


@media only screen and (max-width: 768px) {
    .schema-engine-tabs .schema-tab-list{
        height: auto;
        overflow-x: scroll;
        overflow-y: unset;
}
.schema-detail-page .header {
    margin: 0px 0px !important;
}
.schema-engine-tabs-content {
    padding: 0px 0px 10px !important;
}
}
.schema-engine-array-container-table tbody tr td {
    border-right: 0px;
    border-bottom-width :0px;
    padding: 0px 4px 0px 0px;
}
 
.schema-engine-array-container-table .form-control:disabled,
.schema-engine-array-container-table .form-control{
    margin: 0px 0px !important;
   /* height: 30px !important; */
}

.schema-engine-array-container-table > :not(:first-child) {
    border-top: 0px ;
  }
 
.schema-tab-list .nav-item a{
    color: #6e6e6e;
    background-color: #fff;
    margin: 0 0rem 0.5rem 0.5rem;
    border: 1px solid rgba(0, 0, 0, 0.175);
    border-radius: 4px;  
    box-shadow: 0 2px 6px 0 rgba(67,89,113,.12);
    width: auto;
}
@media only screen and (max-width: 768px) {
    .schema-tab-list .nav-item a{ 
        width: max-content;
    }
}

.schema-engine-tabs .schema-tab-list .nav-item .nav-link.active {  
    color: #fff;
    background-color: #182535;
    box-shadow: 1px 2px 3px 0px #0000;
   /* margin-right: 0px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    font-weight: bold;888*/
}

.schema-engine-tabs .schema-tab-list  .nav-item .nav-link:hover, .schema-engine-tabs .schema-tab-list .nav-item .nav-link:focus  {
    text-decoration: none;
    color: white;
    background-color: #182535;
}
.ow-dashboard {
        min-height: calc(100vh - 80px) !important;
}
.ow-dashboard .schema-engine-tabs-content{
    height: calc(100vh - 140px) !important;
}

.schema-engine-tabs-content{
    padding: 0px 10px 10px;
    width: 100%;
    height: var(--tab-height-default);
    overflow-y: scroll;
   
}

.child-table-wrapper-impersonated .schema-engine-tabs-content{
    padding: 0px 10px 10px;
    width: 100%;
    height: var(--tab-height-impersonated);
    overflow-y: scroll;
}


.child-tab-wrapper .schema-detail-page .body{
    height: var(--tab-height-default) !important;
}

.child-tab-wrapper-impersonated .schema-detail-page .body{
    height: var(--tab-height-impersonated) !important;
}   




.ow-dashboard .schema-detail-page .body{

    height: calc(100vh - 140px) !important;
}
.ow-dashboard.impersonated .schema-detail-page .body{   
    height: calc(100vh - 180px) !important;
}

@media only screen and (max-width: 768px) {
    .child-tab-wrapper.ow-dashboard  .schema-detail-page .body{
     overflow:overlay;
         height:auto;
     }
     .ow-dashboard .schema-engine-tabs-content {
         height: calc(100svh - 220px);
     }
     .child-tab-wrapper-impersonated .schema-detail-page .body {
        height: calc(100svh - 250px) !important;
    }
    
 }

.schema-engine-card {
    width: calc(100% - 0.6rem);
    margin: 0.3rem 0.3rem 0.3em 0.3rem;
    box-shadow: 0 2px 6px 0 rgba(67,89,113,.12);
}
.schema-engine-card .card-header{
    font-weight: bold !important;
    border-bottom: 0px;
    font-size: 1.1rem;
    background-color: #fff;
}

.schema-engine-card .bg-secondary > .card-header{
    background-color: #6c757d ;
}


.schema-engine-card-action-buttons {
    display: flex;
    flex-direction: row;
}

.schema-engine-card-action-buttons > * {
    margin-left: 5px;
}

.schema-engine-card-top-right-control {
    position: absolute;
    top: 8px; /* Adjust as needed */
    right: 0px; /* Adjust as needed */
    z-index: 1;
    text-align: right;
}

.schema-engine-dashboard-card .schema-engine-card-top-right-control .dropdown-toggle::after{
    display: none;
}


.schema-engine-card  .card-header:first-child {
    border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.schema-engine-card-width-column1 {
    /* OBSOLETE - delete: width: calc(100%); */
}
.schema-engine-card-width-column2 {
    /*  OBSOLETE - delete: width: calc(100% / 2 - 1rem); */
}
.schema-engine-card-width-column3 {
    /*  OBSOLETE - delete: width: calc(100% / 1 - 1rem); */
}

.schema-engine-card-100-percent {
    width: calc(100% - 0.6rem);
    height: calc(100% - 0.6rem);
}

.schema-engine-card-100-percent .card-body{
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0px;
}


.custom-dot-list-style{
    margin-top: 20px;
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and  (max-width: 999px){

    .schema-engine-card { 
        margin: 0 0rem 0.5rem 0;
    }

    .col-form-label{
        padding-top: 0% !important;
    }
    .navbar-collapse {
        max-height: 300px;
        overflow-y: scroll;
    }

}



/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1000px) { 

}
.schema-engine-dashboard-card {
    border: 1px solid #d6d6d6;
    box-shadow: rgba(67, 89, 113, 0.12) 0px 2px 6px 0px;
    overflow: visible !important;
}
.schema-engine-dashboard-card .card-header .schema-engine-card-header-title{
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.schema-engine-dashboard-card .card-header{
    background-color: transparent !important;
    border-bottom: 0px;
    font-size: 1rem;
    color: #666; 
}
.schema-engine-dashboard-card .card-header .schema-engine-card-action-buttons button{
    padding-right: 0px;
    padding-left: 0px;
}
.schema-engine-dashboard-card .card-header .schema-engine-card-action-buttons .dropdown-toggle::after{
    display: none;
}
.__schema-engine-dashboard-card .card-header i{
    font-size: 1.8rem;
    color: #cc4748;
}
.schema-engine-dashboard-card .card-body{
padding: 0.2rem 0.5rem; 
overflow-x: hidden;
overflow-y: auto;
}
.schema-engine-dashboard-card-layout-2
{
    height: 100%;
    width: 100%;
    overflow-block: clip;
 overflow: hidden;
}
.schema-engine-dashboard-card-layout-3
{
    height: 100%;
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content:space-between;
    align-items: center;
}
.schema-engine-dashboard-status-elem  {
    font-size: 1rem;
    text-align: center;
}
.schema-engine-dashboard-status-elem.schema-engine-dashboard-default-variant{
    display: flex; 
    flex-wrap: wrap;
    justify-content:center;
    height: 100%;
}
.schema-engine-dashboard-status-elem .schema-engine-dashboard-status-elem-value{
    font-size: 2.5rem;
}
.schema-engine-dashboard-status-elem .schema-engine-dashboard-status-elem-description{
    color: #99A1B7;
}
/* ------------------------------------------------------------------------------- *
 *- pagination style start ----------------------------------------------------------- *
 * ------------------------------------------------------------------------------- */
 .page-link{
    color: #212529;  
    padding: .2rem 0rem;
    border-color: #000;
 }

 .page-link:hover {
    z-index: 2;
    color: #fff;
    background-color: #212529;
    border-color: #000;
 }
.page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: #212529;
    border-color: #212529;
}
.page-item:disabled  .page-link {
    border-color: #dee2e6 !important;
}
.page-item.disabled:hover{
    cursor: not-allowed !important;
}

.page-item:last-child .page-link,
.page-item:first-child .page-link {
    
}
.pagination{

  margin-bottom: 5px;
}
/*.pagination div{    
border: 1px solid #000;
}*/

.pagination .previous, .pagination .next {
    cursor: pointer;
position: relative;
display: block;
color: #212529;
border: 1px solid #000;
text-decoration: none;
background-color: #fff;
padding: .1rem .75rem;
}
.pagination .previous{
    border-top-left-radius:.25rem;
    border-bottom-left-radius:.25rem ;
}

.pagination .next{
    border-top-right-radius:.25rem ;
    border-bottom-right-radius:.25rem ;
}
.showing-data .form-select{
    padding: .275rem 2.25rem .175rem .75rem;
    border: 1px solid #000;

}
/*-----------------------------------------------------------------------*/
/*----------------------- breadcrumb style Start ------------------------*/
/*-----------------------------------------------------------------------*/


.breadcrumb {
	/*centering*/
	display: inline-block;
    /*margin-bottom: 10px;
	box-shadow: 0 0 15px 1px rgba(0, 0, 0, 0.35);
	overflow: hidden;
	border-radius: 5px;*/
    padding: 0px 0px !important;
    margin-bottom:0px !important;
	/*Lets add the numbers for each link using CSS counters. flag is the name of the counter. to be defined using counter-reset in the parent element of the links*/
	/*counter-reset: flag; */
}

.breadcrumb div {
	text-decoration: none;
	outline: none;
	display: block;
	float: left;
	font-size: 18px;
    font-weight: 600;
	line-height: 30px;
	color: #000;
	/*need more margin on the left of links to accomodate the numbers*/
	padding: 0 10px ;
/*	background: #666;
	background: linear-gradient(#666, #333);*/
	position: relative; 
}
/*since the first link does not have a triangle before it we can reduce the left padding to make it look consistent with other links*/
.breadcrumb > div:first-child {
	padding-left: 10px;
/*	border-radius: 5px 0 0 5px; /*to match with the parents radius*/ 
}
.breadcrumb div:first-child:before {
	left: 14px;
}
.breadcrumb > div:last-child {
	border-radius: 0 5px 5px 0; /*this was to prevent glitches on hover*/
	padding-right: 10px;
}
.breadcrumb > div small{
    color: #7a7a7a;
    font-size: small;
    margin-left: 5px;
    font-weight: normal;
}

/*hover/active styles*/
/*.breadcrumb div.active, .breadcrumb div:hover{
	/*background: #333;
	background: linear-gradient(#333, #000);
} 
.breadcrumb div.active:after, .breadcrumb div:hover:after {
	background: #333;
	background: linear-gradient(135deg, #333, #000);
}*/

/*adding the arrows for the breadcrumbs using rotated pseudo elements*/
.breadcrumb > div.cursor-pointer::after {
	content: '>';
	position: absolute;
	top: 0; 
    right: -4px; /*half of squares length*/
	/*same dimension as the line-height of .breadcrumb a */

/* width: 28px;
height: 30px; */
	/*as you see the rotated square takes a larger height. which makes it tough to position it properly. So we are going to scale it down so that the diagonals become equal to the line-height of the link. We scale it to 70.7% because if square's: 
	length = 1; diagonal = (1^2 + 1^2)^0.5 = 1.414 (pythagoras theorem)
	if diagonal required = 1; length = 1/1.414 = 0.707*/

/*    transform: scale(0.707) rotate(45deg);
	/*we need to prevent the arrows from getting buried under the next link*/
/*	z-index: 1;
	/*background same as links but the gradient will be rotated to compensate with the transform applied*/
/*	background: #666;
	background: linear-gradient(135deg, #666, #333);
	/*stylish arrow design using box shadow*/
/*	box-shadow: 
		2px -2px 0 2px rgba(0, 0, 0, 0.4), 
		3px -3px 0 2px rgba(255, 255, 255, 0.1);
	/*
		5px - for rounded arrows and 
		50px - to prevent hover glitches on the border created using shadows*/
        
 /*  box-shadow:  2px -2px 0 2px #ebf3f1;
	border-radius: 0 5px 0 50px;*/
}
/*we dont need an arrow after the last link*/
.breadcrumb > div.cursor-pointer:last-child::after {
	content: none !important;
}

/*we will use the :before element to show numbers*/
/*.breadcrumb a:before {
	/*content: counter(flag);
	counter-increment: flag;*/
	/*some styles now*/
	/*border-radius: 100%;
	width: 20px;
	height: 20px;
	line-height: 20px;
	margin: 8px 0;
	position: absolute;
	top: 0;
	left: 30px;
	background: #444;
	background: linear-gradient(#444, #222);
	font-weight: bold;
}*/


.flat a, .flat a:after {
	background: white;
	color: black;
	transition: all 0.5s;
}
.flat a:before {
	background: white;
	box-shadow: 0 0 0 1px #ccc;
}
.flat a:hover, .flat a.active, 
.flat a:hover:after, .flat a.active:after{
	background: #9EEB62;
}
/*-----------------------------------------------------------------------*/
/*----------------------- breadcrumb style end ------------------------*/
/*-----------------------------------------------------------------------*/

.copy-device{
    cursor: pointer;
    color: #868888;
}
.copy-device:hover{    
    color: #1e6f8d;
}

.NetworkMapWarpper {
    position: absolute;
    flex-direction: column;
    width: 350px;
    height: 100%;
    top: 0px;
    left: 0px;
    z-index: 999;
    border:1px solid #000;
    display: flex;
}

.ow-app-map-left-sliding-panel {
    position : absolute;
    width: 350px;
    height: 100%;
    top: 0px;
    left: 0px;
    display: flex;
    flex-direction : row;
    z-index: 999;
    border:0px solid;
}

.ow-app-map-left-sliding-panel .ow-app-map-left-sliding-panel-inner {
    position :relative;
    top:0;
    left:0;
    width: 300px;
    height:100%;
    display: flex;
    flex-direction : column;    
    background-color: rgb(255, 255, 255);
    padding-top: 10px;

}



#NetworkMap {
    width: 300px;
    height: 100%;
    top: 0px;
    left: 0px;
    display: flex;
    flex-direction: column;
    z-index: 999;
    border: 1px none;
    padding: 10px;
    background-clip: padding-box;
    /*background-color: rgba(250,250,250, 0.8);*/
    box-shadow:2px 3px 5px #80808096;
}

#NetworkMap .has-success .form-control,
#NetworkMap .has-success .input-group-addon {
    border-color: #78b97f;
}

#NetworkMap .search_input_wrapper {
    /*z-index: 409;
    position: absolute;
    left: 30px;
    top: 105px;
    width: 225px;
    box-shadow: -6px 6px 5px #80808096;*/
    border-radius: 5px;
    margin-bottom:10px; 
    padding:0px 10px
    /*box-shadow: -6px 6px 5px #80808096;*/
}

#NetworkMap .search_input_wrapper > div {
    margin-bottom: 0;
    border-radius: 5px;
}

#NetworkMap .search_input_wrapper > div .input-group-addon {
    background: rgba(250, 250, 250, 0.8);
    color: #000;
}

#NetworkMap .search_input_wrapper > div.has-success .input-group-addon {
    color: #333;
}

#NetworkMap .search_input_wrapper > div input {
      /* border-left: none;*/
    background: rgba(250, 250, 250, 0.8);
}

#NetworkMap .custom_control {
    /*position: absolute;
    left: 30px;
    bottom: 20px;
    z-index: 409;
    width: 225px;*/
    box-shadow: -6px 6px 5px #80808096;
    background-color: rgba(250,250,250, 0.8);
    padding: 0px 0 0 10px;
    border-radius: 5px;
    border: 1px solid #ddd;
    color: #333;
    font-size: 14px;
    background-clip: padding-box;
    margin-bottom: 20px;
}


#NetworkMap .device_list {
    /* position: absolute;
    left: 30px;
    bottom: 20px;
    z-index: 409;*/
    /*box-shadow: -6px 6px 5px #80808096;*/
    height: 100%;
    background-color: rgba(250,250,250, 0.8);
    /*padding: 0px 0 0 10px;*/
    /*border-radius: 5px;*/
    /*border: 1px solid #ddd;*/
    color: #333;
    font-weight: 700;
    /*background-clip: padding-box;*/
    overflow: auto;
    /* margin-bottom: 10px; */
    padding:0px 0px
}

/*
#NetworkMap .custom_control > .checkbox {
    margin-top: 5px;
    margin-bottom: 5px;
}*/

#NetworkMap .device_list .table{
    margin-bottom: 0px;
}

#NetworkMap .saveButton {
    position: absolute;    
    right: -40px;
    bottom: 10px;
    width: 30px;
    height: 30px;
    z-index: 409;
    padding: 0px;
}

#NetworkMap .card{
    background-color: transparent !important;
}

#NetworkMap .card .card-body {
    padding: 0px;
}

#NetworkMap #map-device-list-panel {
    z-index: 409;
   /* width: 225px;*/
    top: 150px;
    left: 30px;
}
#NetworkMap #map-device-list-panel .table>tbody>tr>td {
    background-color: transparent !important;
    padding: 4px 8px;
    font-weight: normal;
}

#NetworkMap #map-device-list-panel .no-position > td {
    opacity: 0.5;
    padding: 8px;
    background-color: transparent !important;
}

#NetworkMap #map-device-list-panel tr > td #gateway_icon.green_icon {
    color: #008000;
}

#NetworkMap #map-device-list-panel tr > td #gateway_icon.red_icon {
    color: #ff0000;
}

#NetworkMap #map-device-list-panel .no-position #no_position_icon {
    width: 17px;
    float: right;
    position: relative;
    right: 3px;
    top: 2px;
}


#NetworkMap .app-side-panel-tab-container {
    position: absolute;
    width: 300px;
    height: 100%;
    top:0;
    left:0;
    display: flex;
    flex-direction: column;
    z-index: 999;
    padding:10px 0px 0px;
    background-color: #FFFFFF;
}


#NetworkMap .app-side-panel-tab-container .tab {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  /*  border-bottom: 1px solid #000;
    margin-bottom: 20px; */
}

#NetworkMap .app-side-panel-tab-container .tab {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-bottom: 10px;
    flex-grow: initial;
}

#NetworkMap .app-side-panel-tab-container .tab .network-map-tab {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    border-bottom: 1px solid #ccc;
    /*  margin-bottom: 20px; */
    flex-grow: initial;
    padding-bottom: 10px;
    width:100%;
}
#NetworkMap .app-side-panel-tab-container .tab .network-map-tab:hover{
    cursor: pointer;
}

#NetworkMap .app-side-panel-tab-container .tab .network-map-tab.active {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    border-bottom: 2px solid #000;
  /*  margin-bottom: 20px; */
    flex-grow: initial;
    font-weight: 700;
    width:100%;
}

.ow-nst-map-left-sliding-panel .slide-button .btn-sm ,
.ow-app-map-left-sliding-panel .slide-button .btn-sm{
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
}

.ow-app-map-left-sliding-panel .slide-button {
z-index: 999;
}
.ow-app-map-left-sliding-panel .slide-button #slide-button {
box-shadow:2px 3px 5px #80808096;
}

.confirm-dialog-title{
    font-size: 1rem;
   /* font-weight: 700; */
    margin-bottom: 0rem;
}

.confirm-dialog-description {
    display: block;  
    word-wrap: break-word;
    overflow-wrap: break-word;
    margin-top: 10px;  
}

.schema-detail-page,
#schema-detail-page-body {
   /* background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 2px 10px #0000001A;*/
    opacity: 1;
    display: flex;
    flex-direction: column;
}

.schema-detail-page .header {
    display: flex;
    flex-direction: row;
    padding: 10px;
    justify-content: center;
    align-items: flex-start;
    /* ---------- style for floating header ----------- */
    margin:0px 10px; 
    position: initial;
height: 60px;
top: 140px;
z-index: 1010;
display: block;
margin-bottom: 0px;
left: 0px;
right: 0px;
/*background-color: #fff;*/
}

.schema-detail-page .header .breadcrumb {
    display: flex;
    flex:1;
    justify-content: start;
    align-items: center;
    padding-left: 0px;
}
.schema-detail-page .header .breadcrumb div:first-child {
    padding-left: 0px;
}

.schema-detail-page .header .buttons {
    display: flex;
    flex:1;
    justify-content: end;
    align-items: center;
}

.schema-detail-page .header .tabs {
    display: flex;
    flex:1;
    justify-content: center;
    align-items: center;
}

.schema-detail-page .body {
    /* display: flex; */
    flex-direction: row;
    margin-top: 0px;
    height: calc(100vh - 150px);
    overflow-y: scroll;
    overflow-x: clip;           /* FIXME: added to avoid horizontal scrollbar on all schema engine views */
}

.child-tab-wrapper-impersonated .schema-detail-page .body {
    flex-direction: row;
    margin-top: 0px;
    max-height: var(--tab-height-impersonated);
    scrollbar-gutter: stable both-edges !important;
    overflow-y: scroll;
    overflow-x: clip;           /* FIXME: added to avoid horizontal scrollbar on all schema engine views */
}

.primary-tabs .btn{
    border-radius: 0px;
    color: #848484;
}

.primary-tabs .btn.active {
    border: 0px;
    border-bottom: 2px solid #000;
    color: #000;
}
.ow-map-search-filter.css-b62m3t-container .css-1s2u09g-control {
    background-color: hsla(0, 0%, 0%, 0.53);
    border-color: hsl(0, 0%, 48.2%);
}
.ow-map-search-filter.css-b62m3t-container .css-1s2u09g-control .css-1d8n9bt .css-14el2xx-placeholder{
    color:#fff !important;
}
.ow-map-search-filter.css-b62m3t-container .css-1s2u09g-control .css-319lph-ValueContainer .css-qc6sy-singleValue {
    color: hsl(0, 0%, 100%);
}
.ow-map-search-filter.css-b62m3t-container .css-1s2u09g-control .css-319lph-ValueContainer .css-14el2xx-placeholder {
    color: hsl(0, 0%, 100%);
}
.ow-map-search-filter.css-b62m3t-container .css-1s2u09g-control .css-319lph-ValueContainer .css-6j8wv5-Input {
    color: hsl(0, 0%, 100%);
}
.ow-profile_uuid {
    text-transform: uppercase;
    font-family: monospace;
}

.ow-profile_uuid {
    text-transform: uppercase;
    font-family: monospace;
}

.font-monospace {
    text-transform: uppercase;
    font-family: monospace;
}

.ow-react-select-custom [class*="container"] [class*="control"] {
    border-color: #dee2e6;
}

.ow-react-select-custom [class*="container"] [class*="control"] > div { 
    min-height: 30px !important;
    overflow: overlay;
}

.ow-react-select-custom [class*="container"] [class*="control"] > div > div { 
    margin: 0px !important;
    padding-bottom: 0px !important
}

.ow-react-select-custom [class*="container"] [class*="control"] > div:nth-child(2) > div {
    padding: 0 8px;
}


.ob-data-table-main-container .css-b62m3t-container .css-t3ipsp-control{
    border-color: #000;
    min-height: 30px !important;
    max-height: 30px !important;
}
.css-b62m3t-container .css-13cymwt-control{
    
    min-height: 30px;
}

.css-b62m3t-container .css-t3ipsp-control{
    min-height: 30px;
}

.css-b62m3t-container .css-t3ipsp-control:hover{
    border-color: #000 !important;
}
.css-b62m3t-container .css-t3ipsp-control:focus {
    outline: none;
}

.css-b62m3t-container .css-13cymwt-control .css-1fdsijx-ValueContainer .css-qbdosj-Input{
    margin: 0px 2px;
}


.css-b62m3t-container .css-t3ipsp-control .css-1fdsijx-ValueContainer .css-qbdosj-Input{
    margin: 0px 2px;
}


.css-b62m3t-container.has-error .css-13cymwt-control {

  border-color: #dc3545 !important;
}
.css-b62m3t-container.has-error .css-13cymwt-control .css-1fdsijx-ValueContainer  .css-1jqq78o-placeholder {
    color: #dc3545;
}

.css-b62m3t-container .css-8aqfg3-menu .css-qr46ko > div:hover, 
.css-b62m3t-container .css-8aqfg3-menu .css-qr46ko > div:focus {
    background-color:#afafaf;
}

.css-b62m3t-container .css-8aqfg3-menu .css-qr46ko > div:active{
     background-color: #000 !important;
}

.css-b62m3t-container .css-1te58xy-menu .css-drjxwl .css-jh5fab-option{
    font-size: 0.9rem !important;
}
.css-b62m3t-container  .css-1nmdiq5-menu{
    min-width: 250px;
}

/*  ::::::::::::::::::::::::::::::::::::::::::::::::::: */
/*  :::::::::::::::    NST Style   :::::::::::::::::::: */
/*  ::::::::::::::::::::::::::::::::::::::::::::::::::: */
.ow-nst-server-status-info span.badge {
    min-width: 180px;    
    border-radius: 25rem !important;
}

.ow-nst-server-status-info .ow-nst-server-status-info-normal {

    background-color: #dff0d8;
    background-color: #777777;
    color: #fff;
}
.ow-nst-server-status-info-ok {
    background-color: #dff0d8;
    border-color: #d6e9c6;
    color: #3c763d;
}
.ow-nst-server-status-info-warning {
    background-color: #f2e4c1;
    border-color: #f2cf82;
    color: #e49626;
}
.ow-nst-server-status-info-critical {
    background-color: #f2dede;
    border-color: #ebccd1;
    color: #a94442;
}
.page-wrapper {
    width: 100%;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    padding-top: 10px;
}
.schema-engine-array-accordian-container .schema-engine-array-accordion-element-object .accordion-header .accordion-button{
    color: #000 !important;
    background-color: #ebebeb;
}
.schema-engine-array-accordian-container .schema-engine-array-accordion-element-object h2{    
    margin-top: 0px !important;
    font-size: 1.2rem;
    margin-bottom: 0px !important;
    font-weight: 600;
}
.schema-engine-array-accordian-container .schema-engine-array-accordion-element-object hr.schema-engine-separator-hr{    
    margin: 5px 0px;
}
.schema-engine-dropdown-no-frame {
    border: none;
}

/* these styles are for the schema engine object container */
.schema-engine-object-container .schema-engine-object-container-item .accordion-header .accordion-button{
    color: #000 !important;
    background-color: #ebebeb;
}

.schema-engine-object-container .schema-engine-object-container-item h2{    
    margin-top: 0px !important;
    font-size: 1.2rem;
    margin-bottom: 0px !important;
    font-weight: 600;

}
.schema-engine-object-container .schema-engine-object-container-item hr.schema-engine-separator-hr{    
    margin: 5px 0px;
}





/*change the scrollbars width */
/* width */
::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1; 
  }
   
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888; 
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555; 
  }
.ow-nst-wrapper .nav-wrapper {
    margin-bottom: 80px;
}

.ow-nst-wrapper .mar-120 {
    margin-bottom: 120px !important;
}

.ow-nst-wrapper .mar-120-mobile {
    margin-bottom: 0px !important;
    margin-top: 120px !important;
}
.ow-nst-map-left-sliding-panel{
    position : absolute;
    width: 460px;
    height: 100%;
    top: 0px;
    left: 0px;
    display: flex;
    flex-direction : row;
    z-index: 999;
}

.ow-nst-map-left-sliding-panel-mobile{
    width: 420px !important;   
}

.ow-nst-map-left-sliding-panel-mobile   .ow-nst-map-left-sliding-panel-inner-mobile{
    width: 85% !important; 
}

.ow-nst-map-left-sliding-panel   .ow-nst-map-left-sliding-panel-inner{
    position :relative;
    top:0;
    left:0;
    width: 440px;
    height:100%;
    display: flex;
    flex-direction : column;    
    background-color: rgb(255, 255, 255);
    padding-top: 10px;
}

/*col-md-12 css-b62m3t-container*/

.ow-nst-map-left-sliding-panel .ow-nst-network_map-id{
    font-family: monospace;
}

.ow-nst-map-gateways-action {
    color: #404040;
  /*  margin: 0px 5px; 
    font-size: 1.2rem !important;

    margin: 2px 2px 2px 2px;
    font-size: 1rem !important;*/

}

.nst-map-tag-select {
    z-index:9999 !important;
    
}
 
.ow-nst-map-gateways-alarm .badge{
    border-radius: 50rem !important;
    border: 0px !important;
    font-weight: 700;
    line-height: 1;
    width: 15px;
    height: 15px;
    color: #fff;
    margin: 0px;
    padding: 0.35em 0.35em;
    font-size: .60em !important;
    top: 2px;
    left: 15px;
}

.css-b62m3t-container{
    z-index: inherit;
    position:relative !important;
    width: 100%;
}

.ow-nst-map-left-sliding-panel .ow-nst-map-left-sliding-panel-inner .search_input_wrapper .css-b62m3t-container .css-1s2u09g-control{
    min-height: 38px;
}
.ow-nst-map-left-sliding-panel .ow-nst-map-left-sliding-panel-inner .search_input_wrapper .css-b62m3t-container .css-1pahdxg-control{
    min-height: 38px;
}
 
.ow-nst-map-left-sliding-panel .ow-nst-map-left-sliding-panel-inner .search_input_wrapper .css-b62m3t-container .css-1s2u09g-control .css-319lph-ValueContainer{
    padding: 0px 8px;
}

.ow-nst-map-left-sliding-panel .ow-nst-map-left-sliding-panel-inner .search_input_wrapper .css-b62m3t-container .css-1pahdxg-control .css-319lph-ValueContainer{
    padding: 0px 8px;
}

.ow-nst-map-left-sliding-panel .ow-nst-map-left-sliding-panel-inner .search_input_wrapper .css-b62m3t-container .css-1s2u09g-control .css-319lph-ValueContainer .css-6j8wv5-Input{
    margin: 0px;
}
  
.ow-nst-map-left-sliding-panel .ow-nst-map-left-sliding-panel-inner .search_input_wrapper .css-b62m3t-container .css-1s2u09g-control .css-g1d714-ValueContainer {
    padding: 0px 8px;
}

.ow-nst-map-left-sliding-panel .ow-nst-map-left-sliding-panel-inner .search_input_wrapper .css-b62m3t-container .css-1s2u09g-control .css-1hb7zxy-IndicatorsContainer .css-tlfecz-indicatorContainer {
    padding:0px 8px;
}
.ow-nst-map-left-sliding-panel .ow-nst-map-left-sliding-panel-inner .search_input_wrapper .css-b62m3t-container .css-1pahdxg-control .css-1hb7zxy-IndicatorsContainer .css-1gtu0rj-indicatorContainer {
    padding:0px 8px;
}
.uppercase{
    text-transform: uppercase;
}


#extra-search-box [class*="container"]  [class*="control"] {
    min-height: 30px;
    color: #000 !important;
}

#extra-search-box [class*="container"]  [class*="menu"] {
    z-index: 1100 !important;
}

#extra-search-box [class*="container"]  [class*="control"]  [class*="ValueContainer"] {
    padding: 0px 8px;
    overflow: auto;
}


#extra-search-box  [class*="container"]  [class*="control"]  [class*="ValueContainer"]  [class*="Input"]{
    margin: 0px;
    padding-bottom: 0px;
    padding-top: 0px;
}

#extra-search-box [class*="container"]  [class*="control"] [class*="IndicatorsContainer"]  [class*="indicatorContainer"] {
    padding: 0px 8px;
}


.ow-status .form-check {
    margin-right: 0rem;
}

.ow-status .form-check .form-check-input:focus {
    border-color: inherit;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
.ow-status .form-check .form-check-input[type="checkbox"] {
    border-radius: 25em;
    margin-top: .15em;
  }
  .ow-status .form-check .form-check-input{
    border: 2px solid rgba(0,0,0,.25);
  }

  .ow-status .form-check.major_issue .form-check-input{
    border-color: #d80606;
  }
.ow-status .form-check.major_issue .form-check-input:checked {
    background-color: #d80606;
    border-color: #d80606;
  }
  .ow-status .form-check.never_seen .form-check-input{    
    border-color: #000000;
  }
   .ow-status .form-check.never_seen .form-check-input:checked {
    background-color: #000000;
    border-color: #000000;
  }
  .ow-status .form-check.ok .form-check-input{    
    border-color: #13b827;
  }
  .ow-status .form-check.ok .form-check-input:checked {
    background-color: #13b827;
    border-color: #13b827;
  }
  .ow-carousel .carousel-container .card .card-footer ul{
    padding-left: 0px;
    list-style: none;
  }
  .ow-carousel .carousel-container .card .card-footer ul li{
    text-align: center;
    padding: 5px 0px;
    border-bottom: 1px solid #ccc;
  }
  .ow-carousel .carousel-container .card .card-footer ul li:last-child{
    border-bottom: 0px;
  }
.ow-device-profile-image{
    height:    revert-layer !important;
 
}

  .slide-button {
    width: 50px;
    height: 100%;
    padding-top: 10px;
    background-color: transparent;
    border:0px solid;
    
}

.single-page-header {
    display:flex;
    flex-direction: row;
   max-height: 60px !important;
}

.col-wise {
    display:flex;
    flex-direction: 'row';
    align-items:center;
}

.col-vertical {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}

.col-vertical.col-vertical-column {
    display:flex;
    flex-shrink: inherit;
}


/* #main {
    width: 350px;
    height: 500px;
    border: 1px solid #c3c3c3;
    display: flex;
    flex-direction:column;
  }
  
  #main .shrink {
    flex-shrink: 1;
    flex-basis: 50px;
    
  }
  
  #main .grow {
    flex-grow: 1;
    flex-basis: 100px;
  } */
  @media only screen and (max-width: 530px) {
    .table-wrapper {
        height: calc(100vh - 250px) !important;
        height: calc(100dvh - 250px) !important;
        height: calc(100svh - 250px) !important;
        width:100%;
    }
    .ow-data-table-container {
        min-height: calc(100vh - 220px) !important;
        min-height: calc(100dvh - 220px) !important;
        min-height: calc(100svh - 220px) !important;

    }
}
@media only screen and (max-width: 991.98px) {
    .ow-data-table-container {
        min-height: calc(100vh - 180px) !important;
        min-height: calc(100dvh - 180px) !important;
        min-height: calc(100svh - 180px) !important;
    }
  
}
@media  (max-width: 767.98px) and (max-height: 950px) {
    .schema-engine-tabs-content{
        height: calc(100vh - 250px) !important;
        height: calc(100dvh - 250px) !important;
        height: calc(100svh - 250px) !important;
    }
}
  @media only screen and (max-width: 768px) {
    .table-wrapper {
        height: calc(100vh - 250px) !important;
        height: calc(100dvh - 250px) !important;
        height: calc(100svh - 250px) !important;
        width:100%;
    }
  

    .wrapper {
        padding-top: 10px;
       /* background: #FFFFFF 0% 0% no-repeat padding-box;*/
        box-shadow: 0px 2px 10px #0000001A;
        margin: 0px 4px;
        border-radius: 4px;
    }

    
    .slide-button {
      /*  position: absolute; */
        width: 50px;
        height: 100%;
        /* top: 95px;*/
        background-color: transparent;
        border:0px solid;
    }

    .ow-nst-map-left-sliding-panel{
        position : absolute;
        width: 100%;
        height: 90%;
        top: 0px;
        left: 0px;
        display: flex;
        /* flex-direction : column; */
        z-index: 999;
        bottom:0;
    }


    .ow-nst-map-left-sliding-panel   .ow-nst-map-left-sliding-panel-inner{
        position :relative;
        top:0;
        left:0;
        width: 100%;
        height:100%;
        display: flex;
        flex-direction : column;    
        background-color: rgb(255, 255, 255);
        padding-top: 10px;
    }

    .single-page-header {
        display:flex;
        flex-direction: row;
        max-height: 140px !important;
    }
}  

@media only screen and (min-width: 768px) and (max-width: 992px){
    .table-wrapper {
        height: calc(100vh - 150px);
        width:100%;
    }
}

.tooltip-inner {
    text-align: left;
}
.tooltip-inner li{
    list-style: none;
}


.uploadIcon {
    width: 100px;
    height: 100px;
}

.no-link {
    text-decoration:none;
}

.fuota-stepper .table-wrapper {
   /* border: 1px solid !important;
*/
    padding : 0 !important;
  }
  
  .fuota-stepper .table-wrapper .single-page-header{
    display: none !important;
  }

  .fuota-stepper-device .table-wrapper .single-page-header{
    display: none !important;
  }
  .fuota-stepper-device .table-wrapper {
    padding : 0 !important;
  }

  .stepper-main {
    height: 60px;
  }

  .stepper-circle {
    height: 30px !important;
     width:30px !important;
        z-index: 9 !important;
    }

    .border-stepper-black {
        border: 1px solid black !important;
    }

  .custom-progress {
    height: 5px !important;
    position: relative !important;
    top: -30% !important;
    background-color: black !important;
  }

  .progress-bar {
    background-color: black !important;
  }
  .step-primary {
    background: #0b0c0d !important;
    border: 1px solid #0b0c0d !important;
  }
.xterm .xterm-screen {

width: 1200px !important;
}

.expose {
    position:relative;
}

#overlay {
    background:rgba(0,0,0,0.3);
    display:none;
    width:100%; height:100%;
    position:absolute; top:0; left:0; z-index:99998;
}

.badge-map {
    height: 16px !important;
    width : 16px !important;
    border-radius:50% !important;
    color : white !important;
    justify-content: center;
    display: flex;
    align-items: center;
    font-size: 75% !important;
    font-weight : 700 !important;
  }

  /* 
  .custom-dropdown > .dropdown > button {
    background: transparent !important;
    border: none !important;
    padding: 0 !important;
    color: #000!important;
    font-size: .875em !important;
  }
  */
.schema-engine-table-type{
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.25);
border-radius: 6px;
}

  .ellipsis-class {
    white-space: nowrap !important; 
    overflow: hidden !important;
    text-overflow: ellipsis !important; 
  }
  .schema-engine-table-type thead tr th {
    color: rgb(5, 106, 157);
    background-color: #64badd;
    border-color: #32383e;
    border-radius: 0px;
    padding: 0.2rem 0.4rem !important;
    font-size: 1rem;
font-weight: 600;
}
.schema-engine-table-type thead tr{
    border-top: 0px;
}



.schema-engine-table {
    overflow: auto;
}

.schema-engine-table-header th {
    color: #495057;
    background-color: #e9ecef;
    border-color: #dee2e6;
  }



.schema-engine-table-type thead tr th:first-child{
    border-top-left-radius: 6px;
}
.schema-engine-table-type thead tr th:last-child{
    border-top-right-radius: 6px;
}
.ow-popover{
    max-width: 200px;
    box-shadow: 0 .2rem 0.3rem rgba(0, 0, 0, 0.38) !important;
    padding-bottom: 10px;
}
.ow-popover.ow-popover-connection-status{
    max-width: 400px;
    padding-bottom: 0px !important;
}
.ow-popover.ow-popover-connection-status .ow-popover-status{
    font-size: small;
    font-style: italic;
}

.ow-popover .popover-header{
    background-color: transparent;
    font-weight: 600;
    border-bottom: 0px;
    padding-left: 0.6rem;
}
.ow-popover .popover-body{
    max-height: 250px;
    overflow-y: auto;
}

.schema-engine-help-popover-big{
    max-width: 800px;
}

.schema-engine-help-popover{
    box-shadow: 0 .2rem 0.3rem rgba(0, 0, 0, 0.38) !important;
}

.schema-engine-help-popover .popover-header{
    background-color: transparent;
    border-bottom: 0px !important;
    font-weight: 600;
}
.schema-engine-help-popover .popover-body{
    padding-top: 0%;
}

.scroll-btn {
    position: fixed !important; 
    width: 50px !important;
    right: 0% !important;
    bottom: 0% !important;
    height: 50px !important;
    font-size: 3rem !important;
    z-index: 999 !important;
    cursor: pointer !important;
    border-radius: 50%;
    color: #fff !important; 
    background-color: #00000082;
    margin-right: 10px;
    text-align: center;
}
.scroll-btn svg{
    font-size: 1.5rem !important;  
    margin-bottom: 20px;
}


      .card-body .form-switch .form-check-input[type="checkbox"][disabled] {
        cursor: not-allowed !important;
        pointer-events : unset !important;
      }

      .schema-engine-array-accordian-container  {
        margin-left:20px;
        counter-reset: item;
      }
      
      .schema-engine-array-accordian-container .schema-engine-array-accordion-element-object {
          margin:10px 0 10px 0px;
          border-radius: 5px;
          position: relative;
      }
      .schema-engine-array-accordian-container .schema-engine-array-accordion-element-object:before {
            content: "";
            counter-increment: item; 
            position: absolute;
            top:-10px;
            left:-20px;  
            border-left: 0.1rem solid #acacac;
            border-bottom: 0.1rem solid #acacac;
            width: 20px;
            height: 40px;
            border-bottom-left-radius: 12px;
          }
          .schema-engine-array-accordian-container .schema-engine-array-accordion-element-object:after {
            position:absolute;
            content:"";
            top:20px;
            left:-20px;  
            border-left: 0.1rem solid #acacac;
            border-bottom: 0.1rem solid #acacac;
            width:0px;
            height:100%;
          }
          .schema-engine-array-accordian-container .schema-engine-array-accordion-element-object:last-child:after {
            display:none;
          }
          .schema-engine-array-accordian-container .schema-engine-array-accordion-element-object h2 {
            display:block; 
            color:rgba(102,102,102,1);
            text-decoration:none;
          }
          .schema-engine-array-accordian-container .schema-engine-array-accordion-element-object h:before{ 
            content: counters(item, ".") " ";    
          }



.schema-engine-dropzone,
.schema-engine-dropzone > div {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
}          
.dropzone {
    min-height: auto;
    padding: 1.5rem 1.75rem;
    text-align: center;
    cursor: pointer;
    border: 1px dashed #c3c3c3;
    background-color: #fff;
    border-radius: .475rem!important;
}

.dropzone.dz-clickable .dz-message, .dropzone.dz-clickable .dz-message * {
    cursor: pointer;
}
.dropzone .dz-message {
    margin: 0;
    display: flex;
    text-align: left;
}
.dropzone .dz-message h3{
    margin-top: 0px;
}

.schema-engine-status-list .list-group-item{
    padding: 0px;
}

.schema-engine-simple-page {
    background-color: white;
    max-height: calc(100vh - 120px) !important;
    min-height: calc(100vh - 120px) !important;
  border-radius: 0.5rem ;
  overflow-y: scroll;
  padding: 0.5rem;
  box-shadow: 0 2px 6px 0 rgba(67,89,113,.12);


}
.schema-engine-logs-content .schema-engine-logs-content-empty{
    text-align: center;

}
.ow-state  {
    width: 100%;
}

.schema-engine-no-breadcrumb-wrapper{
    max-height: calc(100vh - 80px) !important;
    position: relative;
    overflow: scroll;
}
.fa-90 {
    font-size: 0.925em !important;
}
.fa-80 {
    font-size: 0.825em !important;
}
.fa-75 {
    font-size: 0.750em !important;
}   
.fa-85 {
    font-size: 0.850em !important;
}
.fa-60 {
    font-size: 0.60em !important;
}
.text-bg-green{
    background-color: #ddf6d7;
border-color: #ddf6d7;
color: #2e8e19;
}

.text-bg-blue{
    background-color: #dbecfb !important;
    border: 1px solid #dbecfb;
    color: #3172ad;
}
.text-bg-red{
    background-color: #f4d5d5;
    border: 1px solid #f4d5d5;
    color: #f13b46;
}
.text-bg-darkorange{
    background-color: #f1dba5;
    border: 1px solid #f1dba5;
    color: #b97f2b;
}
.text-bg-yellow{
    background-color: #f0dba6 !important;
    border:1px solid #cfad58;
    color: #aa872c;
}

.livelog-date {

    background-color: #dff0d8; 
    border-color: #d6e9c6;
    color: #3c763d;
    padding: 4px 6px;
    font-size: 0.9em;
}

.livelog-event {    

    background-color: #dff0d8;
    border-color: #d6e9c6;
    color: #3c763d;
    padding: 4px 6px;
    font-size: 0.9em;
}
.livelog-lamdha {

    background-color: #f2e4c1;
    border-color: #f2cf82;
    color: #e49626;
    font-size: 0.9em;
    padding: 4px 6px;
}
.livelog-deviceUuid {

    background-color: #D0F6FF;
    border-color: #A3E7FF;
    color: #076d9f;
    font-size: 0.9em;
    padding: 4px 6px;
}
.livelog-connectionUuid {
    background-color: #D0F6FF;
    border-color: #A3E7FF;
    color: #076d9f;
    font-size: 0.9em;
    padding: 4px 6px;
}

.livelog-error {
    background-color: rgb(247, 184, 184);
    color: rgb(163, 59, 59);
    font-size: 0.9em;
    border-color: rgb(247, 184, 184);
    padding: 4px 6px;
}

.log-search-bar {
    width: 100%;
    padding: 4px 10px;
    margin-bottom: 5px;
    box-sizing: border-box;
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
}

.health-badge-suspended {
    background-color: rgb(247, 184, 184);
    color: rgb(163, 59, 59);
    font-size: 0.7em;
    border-color: rgb(247, 184, 184);
    padding: 4px 6px;
}



/* Map Pop Up Class*/

.max-three-lines {
    max-height: calc(3 * 1.2em); 
    overflow-y: auto; /* Change from hidden to auto for vertical scrolling */
    display: -webkit-box;
    -webkit-line-clamp: 3; /* Number of lines to display */
    -webkit-box-orient: vertical;
    white-space: normal;
    margin-left: 3.5px;
    word-wrap: break-word;
}


.opearational-status-light-gray {
    color: #d3d3d3;
}

.opearational-status-dark-gray {
    color: #666;
}

.opearational-status-yellow {
    color: #E4A11B
}

.opearational-status-green {
    color: #038838;
}

.opearational-status-light-green {
    color: rgb(199, 251, 199);
}

.opearational-status-red {
    color: #ff0000;
}

.opearational-status-dark-red {
    color: #8b0000;
}

.bulk_action_checkbox .form-check-input {
    border-color: #8e8b8b;
}

[class*="ValueContainer"] [class*="placeholder"] {
    /* styles */
    font-size: .875rem;
    color: #d4d4d4;
  }


.breadcrumb-dropdown-menu {
    max-height: 400px;
    overflow-y: scroll;
}

/*-----------------------------------------------------------------------*/
/*----------------------- Dashboard grid-stack cards style start ------------------------*/
/*-----------------------------------------------------------------------*/

.grid-stack-item{

}

/*-----------------------------------------------------------------------*/
/*----------------------- Dashboard grid-stack cards style end ------------------------*/
/*-----------------------------------------------------------------------*/


/*----------------------------------redoc style-------------------------------------*/
.redoc-wrap .menu-content {
    height: calc(100vh - 130px) !important;
}

.redoc-wrap .menu-content  .sc-gfopwy {
    display: none;
}


/*-------------------swagger page style-------------------------*/
.swagger-ui .info {
    margin: 10px 0 !important;
}
.swagger-ui .scheme-container {
    background: transparent !important;
    box-shadow: none !important;
    margin: 0 0 0px !important;
    padding: 0px 0 !important;
}




.alert {
    font-size: 0.6rem !important;
    padding: 0.5rem;
}

.alert .alert-heading.h4 {
    font-size: 0.8rem !important;
}
.alert-danger .alert-heading {
    color: #ce0008;
}
.alert-danger{
    background-color: #fffbfc !important;
    border-color: #f1152c !important;
}
.leaflet-top, .leaflet-bottom{
    
    z-index: 999 !important;
}
.form-label {
    margin-bottom: .1rem;
}

.selected-radio {
    background-color: #e0e0e0; /* Dark gray background */
    color: #000; /* Text color for contrast */
    border-radius: 4px; /* Rounded corners for aesthetics */
}

.selected-radio .form-check-input:checked {
    background-color: #000; 
    border-color: #000 ;
}


/* Apply styles to the menu */
.custom-select-menu {
    background-color: #fff !important;
    z-index: 9999 !important;
    min-width: 250px;
  }
  
  /* Style options */
  .custom-select-option {
    background-color: #fff !important;
    color: #000 !important;
  }
  
  /* Style for selected option */
  .custom-select-option--selected {
    background-color: #000 !important;
    color: #fff !important;
  }
  
  /* Style for focused/hovered option */
  .custom-select-option--focused {
    background-color: #afafaf !important;
  }


  /* Tag list styling */
.tag-list {
    list-style-type: none;
    margin-bottom: 0;
    padding-left: 0;
}
  
.tag-list-item {
    padding: 3px 6px;
    margin: 2px 0;
    border-radius: 3px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.abort-btn {
  display: inline-flex;
  align-items: center;
  margin-left: 5px;
  gap: 6px;               /* space between icon and text */
  height: 28px;
  padding: 0 10px;
  background-color: var(--bs-btn-bg, #212529);        /* use BS variable */
  color: var(--bs-btn-color, white);         /* fallback to white if not defined */
  border: none;
  border-radius: var(--bs-btn-border-radius, 4px); /* optional: use BS border-radius variable */
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

/* hover state using BS variable if available */
.abort-btn:hover {
  background-color: var(--bs-btn-hover-bg, #424649);
  color: var(--bs-btn-hover-color, #fff);
}

/* active state using BS variable if available */
.abort-btn:active {
  background-color: var(--bs-btn-active-bg, #111);
  color: var(--bs-btn-active-color, #fff);
}
`, "",{"version":3,"sources":["webpack://./app_react/src/style/orbiwise/style.css"],"names":[],"mappings":"CAAC;IACG,aAAa;AACjB;AACA;IACI,8CAA8C;IAC9C,yBAAyB;IACzB,qCAAqC;IACrC,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;GACnB,+BAA+B;;GAE/B,gBAAgB;;AAEnB;AACA;IACI;MACE,4BAA4B;;IAE9B;IACA;;;AAGJ;AACA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B,uBAAuB;AACvB;AACA;;AAEA;IACI,wBAAwB;IACxB,uCAAuC;IACvC,yCAAyC;IACzC,8CAA8C;AAClD;;;AAGA;IACI,aAAa;AACjB;EACE;IACE,wBAAwB;;AAE5B;;CAEC;IACG,aAAa;AACjB;;AAEA;IACI,gCAAgC;IAChC,aAAa;AACjB;;AAEA;EACE,gCAAgC;IAC9B,aAAa;AACjB;AACA;;;;EAIE;;AAEF;IACI,wCAAwC;AAC5C;;AAEA;IACI,wCAAwC;AAC5C;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,2BAA2B;IAC3B,UAAU;IACV,iBAAiB;AACrB;;AAEA;GACG,sCAAsC;GACtC,UAAU;GACV,iBAAiB;;AAEpB;;AAEA;IACI,sCAAsC;IACtC,UAAU;IACV,iBAAiB;;AAErB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,yCAAyC;IACzC,UAAU;IACV,iBAAiB;CACpB;;CAEA;IACG,0CAA0C;IAC1C,UAAU;IACV,iBAAiB;CACpB;;AAED;EACE;;;4CAG0C;IACxC,0CAA0C;IAC1C,2CAA2C;IAC3C,2CAA2C;CAC9C;+BAC8B;AAC/B;AACA;IACI,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;AAC1C;AACA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;IAC5B,UAAU;AACd;AACA;IACI,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,4CAAiD;;AAErD;AACA;IACI,uBAAuB;IACvB,4CAAmD;;AAEvD;;AAEA;AACA;;;CAGC;IACG,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB,EAAE,mBAAmB;IACtC,oBAAoB,EAAE,mBAAmB;IACzC,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB,EAAE,mBAAmB;IACtC,oBAAoB,EAAE,mBAAmB;IACzC,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB,EAAE,mBAAmB;IACtC,oBAAoB,EAAE,mBAAmB;IACzC,WAAW;AACf;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB,EAAE,mBAAmB;IACtC,oBAAoB,EAAE,mBAAmB;IACzC,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB,EAAE,mBAAmB;IACtC,oBAAoB,EAAE,mBAAmB;IACzC,WAAW;AACf;;AAEA,qDAAqD;AACrD;IACI,gBAAgB,EAAE,yBAAyB;AAC/C;;;;;;AAMA,SAAS,uBAAuB;;AAEhC;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;;AAEvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;GACZ,yBAAyB;IACxB,yBAAyB;IACzB,cAAc;IACd,+BAA+B;AACnC;AACA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,+CAA+C;IAC/C,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,cAAc,CAAC;;AAEnB;IACI,eAAe;CAClB;;;;wBAIuB;AACxB;;AAEA;IACI,yDAAyD;EAC3D;AACF;IACI,gCAAgC;AACpC;AACA;;IAEI,mBAAmB;EACrB;;AAEF;IACI,oCAAoC;IACpC,oCAAoC;IACpC,UAAU;IACV,8BAA8B;AAClC;AACA;;IAEI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,oBAAoB;IACpB,gCAAgC;IAChC,iBAAiB;AACrB;AACA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,uDAAuD;AAC3D;AACA,yCAAyC;AACzC;IACI,cAAc;IACd,WAAW;IACX,+BAA+B;IAC/B,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;IACzB,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;IAChB,qBAAqB;IACrB,qEAAqE;AACzE;;AAEA;IACI,gBAAgB;;AAEpB;AACA;;IAEI,qBAAqB;AACzB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,+CAA+C;AACnD;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,WAAW,CAAC;;;IAGZ;QACI,aAAa;QACb,gBAAgB;MAClB;AACN;IACI,0BAA0B;IAC1B,YAAY;IACZ,WAAW;AACf;CACC;IACG,iBAAiB;IACjB,oBAAoB;IACpB,qBAAqB;AACzB;;;AAGA;;EAEE,yBAAyB;IACvB,eAAe;IACf,8BAA8B;IAC9B,qBAAqB;IACrB,6BAA6B;AACjC;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;AACjC;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;GACG,8CAA8C;IAC7C,WAAW;AACf;;AAEA;;IAEI,wCAAwC;IACxC,qBAAqB;AACzB;;AAEA;IACI,2CAA2C;IAC3C,WAAW;IACX,WAAW;GACZ,sBAAsB;IACrB,SAAS;IACT,WAAW;IACX,OAAO;AACX;;;;AAIA;IACI,mBAAmB;IACnB,4CAA4C;AAChD;;;AAGA;IACI,4CAA4C;AAChD;;AAEA;;IAEI,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,+CAA+C;IAC/C,eAAe;IACf,uCAAuC;AAC3C;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;;;IAGI,yBAAyB;AAC7B;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,oCAAoC;IACpC,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,eAAe;;AAEnB;;;AAGA;IACI,WAAW;IACX,cAAc;IACd,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,uBAAuB;IACvB,oBAAoB;AACxB;;CAEC;;IAEG,WAAW;IACX,gBAAgB;EAClB;;CAED;;IAEG,oCAAoC;CACvC;;AAED;IACI,2BAA2B;AAC/B;AACA;IACI,yDAAyD;IACzD,yBAAyB;AAC7B;;AAEA;;IAEI,yDAAyD;IACzD,sBAAsB;GACvB,oBAAoB;AACvB;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kBAAkB;;AAEtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA,wBAAwB;AACxB;IACI;;QAEI,2BAA2B;QAC3B;IACJ;IACA;QACI,iBAAiB;IACrB;AACJ;AACA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,wBAAwB;IACxB,wCAAwC;AAC5C;;AAEA;IACI,eAAe;AACnB,YAAY;AACZ,SAAS;AACT,aAAa;AACb,cAAc;AACd,mBAAmB;AACnB,SAAS;AACT,UAAU;AACV,sBAAsB;AACtB;;AAEA,wBAAwB;AACxB;IACI;QACI,iBAAiB;IACrB;AACJ;AACA,uBAAuB;AACvB;IACI;QACI,iBAAiB;IACrB;AACJ;AACA,uBAAuB;AACvB;IACI;QACI,gBAAgB;IACpB;IACA;;QAEI,8BAA8B;IAClC;IACA;QACI,kBAAkB;IACtB;IACA;QACI,8BAA8B;QAC9B,2BAA2B;IAC/B;IACA;QACI,2BAA2B;IAC/B;IACA,gCAAgC,gBAAgB,CAAC;IACjD;;QAEI,eAAe;IACnB;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;MACpB;MACA;QACE,gBAAgB;MAClB;MACA;QACE,2BAA2B;MAC7B;MACA;QACE,2BAA2B;MAC7B;MACA;QACE,8BAA8B;MAChC;MACA;QACE,+BAA+B;MACjC;MACA;QACE,6BAA6B;QAC7B,4BAA4B;OAC7B;;;AAGP;;AAEA,2BAA2B;AAC3B;IACI,mDAA4D;IAC5D,2BAA2B;IAC3B,4BAA4B;IAC5B,uCAAuC;IACvC,sBAAsB;IACtB,aAAa;IACb,yDAAyD;IACzD,sDAAsD;IACtD,iDAAiD;IACjD,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;GAClB,mCAAmC;;IAElC,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,mDAAwD;IACxD,aAAa;IACb,sBAAsB;IACtB,4BAA4B;IAC5B,kCAAkC;AACtC;AACA;IACI,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,cAAc;IACd,mCAAmC;AACvC;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,wBAAwB;AAC5B;AACA;IACI,WAAW;AACf,YAAY;AACZ,sBAAsB;AACtB,kBAAkB;AAClB,eAAe;AACf,iCAAiC;AACjC;AACA;IACI,SAAS;IACT,eAAe;AACnB;AACA;IACI,cAAc;IACd,YAAY;EACd,sBAAsB;IACpB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,UAAU;AACd;AACA;;;IAGI;AACJ;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB;AACA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI;QACI,aAAa;QACb,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;AACJ;AACA,yBAAyB;;AAEzB,qBAAqB;AACrB;IACI,eAAe;AACnB;AACA;IACI,oBAAoB;AACxB;AACA;CACC,mDAAkE;EACjE,2BAA2B;IACzB,4BAA4B;IAC5B,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,0BAA0B;IAC1B,eAAe;AACnB;;AAEA,mBAAmB;AACnB;IACI,iBAAiB;IACjB,8BAA8B;AAClC;AACA;IACI,sBAAsB;AAC1B;AACA;;IAEI,wCAAwC;AAC5C;AACA;IACI,iCAAiC;IACjC,yDAAyD;IACzD,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;AACrC;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;AAClB,8DAA8D;IAC1D,mBAAmB;IACnB,WAAW;AACf;;;AAGA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,WAAW;AACf;;AAEA;;;IAGI,oCAAoC;AACxC;;;AAGA;IACI,WAAW;AACf;;AAEA;;IAEI,oCAAoC;IACpC,sBAAsB;AAC1B;;;AAGA;;;IAGI,YAAY;AAChB;;;AAGA;;oFAEoF;;CAEnF;IACG,yBAAyB;AAC7B;AACA;IACI,gCAAgC;AACpC;;;CAGC;IACG,6BAA6B;IAC7B,WAAW;IACX,mBAAmB;IACnB,wBAAwB;AAC5B,0BAA0B;AAC1B;;AAEA;;IAEI,gBAAgB;IAChB,2BAA2B;AAC/B,6BAA6B;AAC7B;;AAEA;IACI,gBAAgB;AACpB;AACA;;AAEA;AACA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,sCAAsC;IACtC,kBAAkB;IAClB,iBAAiB;EACnB;;AAEF;IACI,qBAAqB;AACzB;;;AAGA;IACI;QACI,YAAY;QACZ,kBAAkB;QAClB,iBAAiB;AACzB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,gCAAgC;AACpC;AACA;AACA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,wBAAwB;AAC5B;;AAEA;;IAEI,0BAA0B;GAC3B,6BAA6B;AAChC;;AAEA;IACI,gBAAgB;EAClB;;AAEF;IACI,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,sCAAsC;IACtC,kBAAkB;IAClB,2CAA2C;IAC3C,WAAW;AACf;AACA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iCAAiC;GAClC;;;0BAGuB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;AACA;QACQ,yCAAyC;AACjD;AACA;IACI,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,iCAAiC;IACjC,kBAAkB;;AAEtB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,sCAAsC;IACtC,kBAAkB;AACtB;;;AAGA;IACI,4CAA4C;AAChD;;AAEA;IACI,iDAAiD;AACrD;;;;;AAKA;;IAEI,sCAAsC;AAC1C;AACA;IACI,sCAAsC;AAC1C;;AAEA;IACI;KACC,gBAAgB;SACZ,WAAW;KACf;KACA;SACI,4BAA4B;KAChC;KACA;QACG,uCAAuC;IAC3C;;CAEH;;AAED;IACI,0BAA0B;IAC1B,kCAAkC;IAClC,2CAA2C;AAC/C;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;;;AAGA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ,EAAE,qBAAqB;IAC/B,UAAU,EAAE,qBAAqB;IACjC,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,oFAAoF;AACxF;;AAEA;IACI,0CAA0C;AAC9C;AACA;IACI,sDAAsD;AAC1D;AACA;IACI,sDAAsD;AAC1D;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,eAAe;AACnB;;;AAGA;IACI,gBAAgB;AACpB;AACA,qDAAqD;AACrD;;IAEI;QACI,uBAAuB;IAC3B;;IAEA;QACI,0BAA0B;IAC9B;IACA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;AAEJ;;;;AAIA,oEAAoE;AACpE;;AAEA;AACA;IACI,yBAAyB;IACzB,mDAAmD;IACnD,4BAA4B;AAChC;AACA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA;AACA,sBAAsB;AACtB,kBAAkB;AAClB,gBAAgB;AAChB;AACA;;IAEI,YAAY;IACZ,WAAW;IACX,oBAAoB;CACvB,gBAAgB;AACjB;AACA;;IAEI,YAAY;IACZ,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;;oFAEoF;CACnF;IACG,cAAc;IACd,mBAAmB;IACnB,kBAAkB;CACrB;;CAEA;IACG,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,kBAAkB;CACrB;AACD;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,8BAA8B;AAClC;;AAEA;;;AAGA;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE;;AAEF;IACI,eAAe;AACnB,kBAAkB;AAClB,cAAc;AACd,cAAc;AACd,sBAAsB;AACtB,qBAAqB;AACrB,sBAAsB;AACtB,qBAAqB;AACrB;AACA;IACI,6BAA6B;IAC7B,iCAAiC;AACrC;;AAEA;IACI,+BAA+B;IAC/B,kCAAkC;AACtC;AACA;IACI,uCAAuC;IACvC,sBAAsB;;AAE1B;AACA,0EAA0E;AAC1E,0EAA0E;AAC1E,0EAA0E;;;AAG1E;CACC,YAAY;CACZ,qBAAqB;IAClB;;;qBAGiB;IACjB,2BAA2B;IAC3B,4BAA4B;CAC/B,+JAA+J;CAC/J,wBAAwB;AACzB;;AAEA;CACC,qBAAqB;CACrB,aAAa;CACb,cAAc;CACd,WAAW;CACX,eAAe;IACZ,gBAAgB;CACnB,iBAAiB;CACjB,WAAW;CACX,kEAAkE;CAClE,gBAAgB;AACjB;0CAC0C;CACzC,kBAAkB;AACnB;AACA,qIAAqI;AACrI;CACC,kBAAkB;AACnB,kEAAkE;AAClE;AACA;CACC,UAAU;AACX;AACA;CACC,0BAA0B,EAAE,wCAAwC;CACpE,mBAAmB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;;;;;;;EAOE;;AAEF,sEAAsE;AACtE;CACC,YAAY;CACZ,kBAAkB;CAClB,MAAM;IACH,WAAW,EAAE,yBAAyB;CACzC,sDAAsD;;AAEvD;eACe;CACd;;oDAEmD;;AAEpD;yEACyE;AACzE;sGACsG;AACtG;;yCAEyC;AACzC;;;;;uEAKuE;;CAEtE;8BAC6B;AAC9B;AACA,4CAA4C;AAC5C;CACC,wBAAwB;AACzB;;AAEA,kDAAkD;AAClD;;0BAE0B;CACzB,kBAAkB;CAClB;;;;;;;;;;;EAWC;;;AAGF;CACC,iBAAiB;CACjB,YAAY;CACZ,oBAAoB;AACrB;AACA;CACC,iBAAiB;CACjB,0BAA0B;AAC3B;AACA;;CAEC,mBAAmB;AACpB;AACA,0EAA0E;AAC1E,wEAAwE;AACxE,0EAA0E;;AAE1E;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,KAAK;IACL,MAAM;IACN,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,oCAAoC;IACpC,iBAAiB;;AAErB;;;;AAIA;IACI,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,4BAA4B;IAC5B,4CAA4C;IAC5C,gCAAgC;AACpC;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI;;;;;wCAKoC;IACpC,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;MACM,sBAAsB;IACxB,oCAAoC;AACxC;;AAEA;IACI;;;;kBAIc;IACd,kCAAkC;IAClC,wCAAwC;IACxC,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,4BAA4B;IAC5B,mBAAmB;AACvB;;;AAGA;IACI;;;kBAGc;IACd,sCAAsC;IACtC,YAAY;IACZ,wCAAwC;IACxC,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;IAC1B,WAAW;IACX,gBAAgB;IAChB,gCAAgC;IAChC,cAAc;IACd,yBAAyB;IACzB;AACJ;;AAEA;;;;EAIE;;AAEF;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;GACb,iBAAiB;IAChB,UAAU;IACV,UAAU;AACd;AACA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,wCAAwC;AAC5C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ;;;AAGA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,KAAK;IACL,MAAM;IACN,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,oBAAoB;IACpB,yBAAyB;AAC7B;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;EAC/B;0BACwB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,6BAA6B;IAC7B,0BAA0B;IAC1B,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;AACd;AACA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,6BAA6B;EAC/B,0BAA0B;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;AACd;;AAEA;;IAEI,sCAAsC;IACtC,yCAAyC;AAC7C;;AAEA;AACA,YAAY;AACZ;AACA;AACA,gCAAgC;AAChC;;AAEA;IACI,eAAe;GAChB,sBAAsB;IACrB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;;GAEG;wCACqC;IACpC,UAAU;IACV,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,qDAAqD;IACrD,eAAe;IACf,iBAAiB;AACrB,YAAY;AACZ,UAAU;AACV,aAAa;AACb,cAAc;AACd,kBAAkB;AAClB,SAAS;AACT,UAAU;AACV,0BAA0B;AAC1B;;AAEA;IACI,aAAa;IACb,MAAM;IACN,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,MAAM;IACN,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,MAAM;IACN,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB,YAAY,0EAA0E;AAC1G;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,0CAA0C;IAC1C,8CAA8C;IAC9C,kBAAkB;IAClB,gBAAgB,YAAY,0EAA0E;AAC1G;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,WAAW;AACf;AACA;IACI,uCAAuC;IACvC,+BAA+B;AACnC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,2BAA2B;AAC/B;AACA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;AACA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,eAAe;AACnB;;;AAGA;;EAEE,gCAAgC;AAClC;AACA;IACI,cAAc;AAClB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;KACK,iCAAiC;AACtC;;AAEA;IACI,4BAA4B;AAChC;AACA;IACI,gBAAgB;AACpB;;AAEA,yDAAyD;AACzD,yDAAyD;AACzD,yDAAyD;AACzD;IACI,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;;IAEI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;AACA;IACI,WAAW;IACX,+CAA+C;IAC/C,iBAAiB;AACrB;AACA;IACI,sBAAsB;IACtB,yBAAyB;AAC7B;AACA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,6BAA6B;IAC7B,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;AAChB;;AAEA,4DAA4D;AAC5D;IACI,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,6BAA6B;IAC7B,gBAAgB;;AAEpB;AACA;IACI,eAAe;AACnB;;;;;;AAMA,+BAA+B;AAC/B,UAAU;AACV;IACI,UAAU;IACV,WAAW;EACb;;EAEA,UAAU;EACV;IACE,mBAAmB;EACrB;;EAEA,WAAW;EACX;IACE,gBAAgB;EAClB;;EAEA,oBAAoB;EACpB;IACE,gBAAgB;EAClB;AACF;IACI,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;AAChC;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,aAAa;IACb,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,KAAK;IACL,MAAM;IACN,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,oCAAoC;IACpC,iBAAiB;AACrB;;AAEA,iCAAiC;;AAEjC;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;EAChB;;;;gCAI8B;;AAEhC;;AAEA;IACI,uBAAuB;;AAE3B;;AAEA;IACI,+BAA+B;IAC/B,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,2BAA2B;IAC3B,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;;AAGA;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,gBAAgB;EAClB;AACF;IACI,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,iCAAiC;EACnC;;EAEA;IACE,qBAAqB;EACvB;AACF;IACI,yBAAyB;IACzB,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;GACC;IACC,yBAAyB;IACzB,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;EAC/B;EACA;IACE,kBAAkB;EACpB;AACF;IACI,kCAAkC;;AAEtC;;EAEE;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,6BAA6B;IAC7B,gBAAgB;;AAEpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;GACpB,2BAA2B;AAC9B;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;;AAGA;;;;;;;;;;;;;;;;;KAiBK;EACH;IACE;QACI,sCAAsC;QACtC,uCAAuC;QACvC,uCAAuC;QACvC,UAAU;IACd;IACA;QACI,0CAA0C;QAC1C,2CAA2C;QAC3C,2CAA2C;;IAE/C;AACJ;AACA;IACI;QACI,0CAA0C;QAC1C,2CAA2C;QAC3C,2CAA2C;IAC/C;;AAEJ;AACA;IACI;QACI,sCAAsC;QACtC,uCAAuC;QACvC,uCAAuC;IAC3C;AACJ;EACE;IACE;QACI,sCAAsC;QACtC,uCAAuC;QACvC,uCAAuC;QACvC,UAAU;IACd;;;IAGA;QACI,iBAAiB;OAClB,oDAAoD;QACnD,kCAAkC;QAClC,eAAe;QACf,kBAAkB;IACtB;;;IAGA;MACE,yBAAyB;QACvB,WAAW;QACX,YAAY;QACZ,cAAc;QACd,6BAA6B;QAC7B,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,WAAW;QACX,WAAW;QACX,QAAQ;QACR,SAAS;QACT,aAAa;QACb,6BAA6B;QAC7B,YAAY;QACZ,QAAQ;IACZ;;;IAGA;QACI,kBAAkB;QAClB,KAAK;QACL,MAAM;QACN,WAAW;QACX,WAAW;QACX,aAAa;QACb,uBAAuB;QACvB,oCAAoC;QACpC,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;AACJ;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;;;AAGA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;GACG;CACF;IACG,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;KACtB,qBAAqB;QAClB,qBAAqB;IACzB;;IAEA;QACI,kCAAkC;IACtC;;EAEF;IACE,sBAAsB;IACtB,6BAA6B;IAC7B,oBAAoB;IACpB,kCAAkC;EACpC;;EAEA;IACE,kCAAkC;EACpC;EACA;IACE,8BAA8B;IAC9B,oCAAoC;EACtC;AACF;;AAEA,wBAAwB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,UAAU,EAAE,WAAW;IACvB,iBAAiB,EAAE,KAAK,EAAE,MAAM,EAAE,aAAa;AACnD;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,4BAA4B;IAC5B,wBAAwB;IACxB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,4BAA4B;EAC9B;;EAEA;;;;;;;;GAQC;AACH;IACI,2CAA2C;AAC/C,kBAAkB;AAClB;;EAEE;IACE,8BAA8B;IAC9B,2BAA2B;IAC3B,kCAAkC;EACpC;EACA;IACE,uBAAuB;IACvB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;AACnB,gBAAgB;AAChB;AACA;IACI,eAAe;AACnB;;;;AAIA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;EACvB;;;;AAIF;IACI,2BAA2B;AAC/B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,gBAAgB;IAChB,yDAAyD;IACzD,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,8BAA8B;AAClC;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;IACrB,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;IACvB,0BAA0B;IAC1B,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,4BAA4B;IAC5B,mBAAmB;AACvB;;;MAGM;QACE,8BAA8B;QAC9B,iCAAiC;MACnC;;MAEA;QACE,gBAAgB;QAChB,mBAAmB;MACrB;;MAEA;UACI,sBAAsB;UACtB,kBAAkB;UAClB,kBAAkB;MACtB;MACA;YACM,WAAW;YACX,uBAAuB;YACvB,kBAAkB;YAClB,SAAS;YACT,UAAU;YACV,iCAAiC;YACjC,mCAAmC;YACnC,WAAW;YACX,YAAY;YACZ,+BAA+B;UACjC;UACA;YACE,iBAAiB;YACjB,UAAU;YACV,QAAQ;YACR,UAAU;YACV,iCAAiC;YACjC,mCAAmC;YACnC,SAAS;YACT,WAAW;UACb;UACA;YACE,YAAY;UACd;UACA;YACE,aAAa;YACb,yBAAyB;YACzB,oBAAoB;UACtB;UACA;YACE,gCAAgC;UAClC;;;;AAIV;;IAEI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,eAAe;AACnB;AACA;IACI,SAAS;IACT,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,0CAA0C;IAC1C,0CAA0C;EAC5C,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,2CAA2C;;;AAG7C;AACA;IACI,kBAAkB;;AAEtB;AACA;IACI,WAAW;AACf;;AAEA;IACI,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,4BAA4B;AAChC;AACA;IACI,yBAAyB;AAC7B,qBAAqB;AACrB,cAAc;AACd;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,oCAAoC;IACpC,wBAAwB;IACxB,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;AACA;;IAEI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;AACA;;IAEI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;AACpB;;;;AAIA,oBAAoB;;AAEpB;IACI,2BAA2B;IAC3B,gBAAgB,EAAE,sDAAsD;IACxE,oBAAoB;IACpB,qBAAqB,EAAE,+BAA+B;IACtD,4BAA4B;IAC5B,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;AACzB;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;EAChB;;;AAGF;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,0EAA0E;AAC1E,0FAA0F;AAC1F,0EAA0E;;AAE1E;;AAEA;;AAEA,0EAA0E;AAC1E,wFAAwF;AACxF,0EAA0E;;;AAG1E,qFAAqF;AACrF;IACI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;AACjB;;;AAGA,iEAAiE;AACjE;IACI,yBAAyB;AAC7B;AACA;IACI,kCAAkC;IAClC,2BAA2B;IAC3B,0BAA0B;IAC1B,yBAAyB;AAC7B;;;;;AAKA;IACI,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,4BAA4B;AAChC;AACA;IACI,cAAc;AAClB;AACA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;AACA;;IAEI,uBAAuB;AAC3B;AACA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB,EAAE,yBAAyB;IACpD,WAAW,EAAE,4BAA4B;IACzC,kBAAkB,EAAE,mCAAmC;AAC3D;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;;AAGA,6BAA6B;AAC7B;IACI,iCAAiC;IACjC,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA,kBAAkB;EAClB;IACE,iCAAiC;IACjC,sBAAsB;EACxB;;EAEA,8BAA8B;EAC9B;IACE,iCAAiC;IACjC,sBAAsB;EACxB;;EAEA,qCAAqC;EACrC;IACE,oCAAoC;EACtC;;;EAGA,qBAAqB;AACvB;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ,gBAAgB,gCAAgC;EACxD,YAAY;EACZ,eAAe;EACf,2CAA2C,SAAS,oBAAoB;EACxE,iCAAiC,UAAU,qCAAqC;EAChF,YAAY;EACZ,+CAA+C,EAAE,4CAA4C;EAC7F,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA,+CAA+C;AAC/C;EACE,iDAAiD;EACjD,sCAAsC;AACxC;;AAEA,gDAAgD;AAChD;EACE,+CAA+C;EAC/C,uCAAuC;AACzC","sourcesContent":[" html {\n    height: 100vh;\n}  \nbody {\n    font-family: \"MarkBook\", sans-serif !important;\n    background-color: #EBF3F1;\n    font-family: proxima-nova, sans-serif;\n    font-weight: 400;\n    font-style: normal;\n    font-size: 0.95rem;\n   /* height: calc(100vh - 81px);*/\n\n   overflow: hidden;\n\n}\n@media screen and (min-width: 1681px){\n    .container, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl {\n      max-width: 1520px !important;  \n     \n    }\n    }\n     \n\n@media screen and (max-width: 1680px) {\n.container, .container-lg, .container-md, .container-sm, .container-xl, .container-xxl {\n  max-width: 1520px;  \n  max-width: calc(100vw - 0px);\npadding: 0px !important;\n}\n}\n\n:root {\n    --navbar-fg-color: white;\n    --navbar-bg-color: var(--bs-body-color);\n    --tab-height-default: calc(100vh - 180px);\n    --tab-height-impersonated: calc(100vh - 220px);\n}\n\n \n*:focus {\n    outline: none;\n}\n  .btn:focus, .btn.focus {\n    outline: none !important;\n   \n}\n\n #root{\n    height:  100%;\n}\n\n.ob-wrapper {\n    /*  height: calc(100vh - 81px);*/\n    height:  auto;\n}\n\n.ow-nst-wrapper {\n  /*  height: calc(100vh - 81px);*/\n    height:  auto;\n}\n/*\n.ow-nst-wrapper .desktop-menu .top_header_desktop,\n.ow-nst-wrapper .desktop-menu .main_header_desktop{\n    background-color: #757575 !important;\n}*/\n\n.desktop-menu {\n    background-color: var(--navbar-bg-color);\n}\n\n.mobile-menu {\n    background-color: var(--navbar-bg-color);\n}\n\n\n.wrapper {\n    height:  100%;   \n} \n\n.table-wrapper {\n    height: calc(100vh - 120px);\n    width:100%;\n    padding-top: 10px;\n}\n\n.impersonated{\n    height: calc(100vh - 170px) !important;\n}\n\n.batch-registraion-wrapper {\n    height: calc(100vh - 340px);\n    width:100%;\n    padding-top: 10px;\n}\n\n.child-table-wrapper {\n   height: calc(100vh - 110px) !important;\n   width:100%;\n   padding-top: 10px;\n   \n}\n\n.child-table-wrapper-impersonated {\n    height: calc(100vh - 110px) !important;\n    width:100%;\n    padding-top: 10px;\n    \n}\n\n.aggrid-child-table{\n    height: 100% !important;\n    display: flex;\n    flex-direction: column;\n    font-size: 12px;\n}\n\n.aggrid-child-table-impersonated{\n    height: calc(100% - 50px) !important;\n    display: flex;\n    flex-direction: column;\n    font-size: 12px;\n}\n\n.child-tab-wrapper {\n    max-height: calc(100vh - 20px) !important;\n    width:100%;\n    padding-top: 10px;\n }\n\n .child-tab-wrapper-impersonated {\n    min-height: calc(100vh - 130px) !important;\n    width:100%;\n    padding-top: 10px;\n }\n\n.ow-data-table-container {\n  /*  height: calc(100vh - 250px) !important;\n    height: fit-content !important;\n    height: calc(100vh - 220px) !important;\n    height: calc(100vh - 180px) !important;*/\n    min-height: calc(100vh - 210px) !important;\n    min-height: calc(100dvh - 210px) !important;\n    min-height: calc(100svh - 210px) !important;\n /* margin-top: 15px;\noverflow-x: hidden !important;*/\n}\n.ow-data-table-container-impersonated {\n    height: calc(100vh - 220px) !important;\n}\n\n.view-data .ow-data-table-container-impersonated {\n    height: calc(100vh - 250px) !important;\n}\n\n#ow-data-table-container-batch-registration {\n    height: calc(100vh - 200px) !important;\n}\n.table-wrapper-map {\n    height: calc(100vh - 150px);\n    height: calc(100svh - 150px);\n    height: calc(100dvh - 150px);\n    width:100%;\n}\n#map-container-div {\n    width: 100%;\n    height: 100% !important;\n}\n\n@font-face {\n    font-family: \"MarkBook\";\n    src: url(\"../../../resources/fonts/MarkBook.ttf\");\n    \n}\n@font-face {\n    font-family: \"MarkBold\";\n    src: url(\"../../../resources/fonts/MarkBold.woff2\");\n    \n}\n\n.h1, .h2, .h3, h1, h2, h3 {\n/*\n    margin-top: 20px;\n    margin-bottom: 10px;\n*/\n    vertical-align: middle !important;\n}\n\nh1 {\n    font-size: 1.8em;\n    font-weight: bold;\n    margin-top: 0.8em; /* Reduced margin */\n    margin-bottom: 0.4em; /* Reduced margin */\n    color: #333;\n}\n\nh2 {\n    font-size: 1.5em;\n    font-weight: bold;\n    margin-top: 0.7em; /* Reduced margin */\n    margin-bottom: 0.3em; /* Reduced margin */\n    color: #444;\n}\n\nh3 {\n    font-size: 1.2em;\n    font-weight: bold;\n    margin-top: 0.6em; /* Reduced margin */\n    margin-bottom: 0.3em; /* Reduced margin */\n    color: #555;\n}\n\nh4 {\n    font-size: 1em;\n    font-weight: bold;\n    margin-top: 0.5em; /* Reduced margin */\n    margin-bottom: 0.2em; /* Reduced margin */\n    color: #666;\n}\n\nh5, h6 {\n    font-size: 0.9em;\n    font-weight: bold;\n    margin-top: 0.4em; /* Reduced margin */\n    margin-bottom: 0.2em; /* Reduced margin */\n    color: #777;\n}\n\n/* Optional: Add consistent spacing for all headers */\nh1, h2, h3, h4, h5, h6 {\n    line-height: 1.2; /* Maintain readability */\n}\n\n\n\n\n\n*:focus {outline:none !important}\n\n.img-left-logo {\n    min-width: 30px;\n    max-height: 30px;\n    margin-top: 5px;\n    margin-bottom: 5px;   \n    padding-right: 15px;\n\n}\n\n.badge{\n    font-size: 0.8rem;\n    font-weight: normal;\n    margin:2px ;  \n   background-color: #fbfbfb;\n    border: 1px solid #878686;\n    color: #3a3a3a; \n    border-radius: .2rem !important;\n}\n.badge.bg-dark{\n    color: #fff;\n    font-size: 0.75em;\n}\n\n.badge.blue{\n    color: #076d9f;\n    background: #D0F6FF 0% 0% no-repeat padding-box;\n    border: 1px solid #A3E7FF;\n    text-align: left;\n}\n.badge.blue a{\n    color: #076d9f;}\n    \n.wrapper {\n    margin: 0px 4px;\n /*   padding-top: 10px;\n    background: #FFFFFF 0% 0% no-repeat padding-box;\n    box-shadow: 0px 2px 10px #0000001A;\n   \n    border-radius: 4px;*/\n}\n\n.shadow {\n    box-shadow: 0 .2rem 0.3rem rgba(0, 0, 0, 0.38) !important;\n  }\n.has-error > .css-1s2u09g-control{\n    border-color: #dc3545 !important;\n} \n.form-control:disabled, .form-control[readonly] {\n  \n    cursor: not-allowed;\n  }\n\n.css-1insrsq-control {\n    border: 1px solid #ced4da !important;\n    background-color: #e9ecef !important;\n    opacity: 1;\n    cursor: not-allowed !important;\n}\n.css-3iigni-container{\n\n    cursor: not-allowed !important;\n}\n\n.css-3iigni-container .css-16xfy0z-control{\n    background-color: #e9ecef;\n    border: 1px solid #ced4da;\n}\n.css-3iigni-container .css-16xfy0z-control  .css-3w2yfm-ValueContainer .css-1p3m7a8-multiValue {\n    background-color: #aaa;\n}\n\n.form-control::-moz-placeholder{\n    color:#d4d4d4 !important; \n}\n\n#operationalStatusSelect::placeholder{\n    color:#d4d4d4 !important; \n}\n\n.invalid-tooltip {\n    right: 1%;\n    margin-top: -10.1rem;\n    display: inline-block !important;\n    position: initial;\n}\n.css-1insrsq-control .css-1hwfws3 .css-1rhbuit-multiValue{\n    background-color: rgb(187, 187, 187);\n    height:30px !important\n}\n\n.dropdown .dropdown-menu{\n    box-shadow:0 .1rem 0.3rem rgba(0, 0, 0, 0.2) !important;\n}\n/* ---- style for react-datepicker ---- */\n.react-datepicker-wrapper .react-datepicker__input-container input{\n    display: block;\n    width: 100%;\n    min-height: calc(1.5em +   2px);\n    padding: .57rem .5rem;\n    font-size: .875rem; \n    font-weight: 400;\n    line-height: 1;\n    color: #212529;\n    background-color: #fff;\n    background-clip: padding-box;\n    border: 1px solid #ced4da;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    border-radius: .25rem;\n    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n}\n\n.react-datepicker-popper[data-placement^=\"bottom\"] {\n    padding-top: 8px;\n\n}\n.data-table-custom .react-datepicker-wrapper .react-datepicker__input-container input{\n\n    padding: .35rem .5rem;\n}\n.mr-1{\n    margin-right: 5px;\n}\n.mr-2{\n    margin-right: 10px;\n}\n.nav-wrapper {\n    margin-bottom: 80px !important;\n}\n.mar-120 {\n    margin-bottom: 120px !important;\n}\n\n.mar-120-mobile {\n    margin-bottom: 0px !important;\n    margin-top: 150px !important;\n}\n\n.mar-top-120 {\n    margin-top: 150px !important;\n}\n\n.content-wrapper {\n    padding-top: 20px;\n    background: #FFFFFF 0% 0% no-repeat padding-box;\n}\n\n.navbar {\n    margin-bottom: 0;\n    border-radius: 0;\n    padding: 0px;\n} \n.navbar-toggler{\n    border: 0px;}\n\n\n    .navbar-toggler:focus {\n        outline: none;\n        box-shadow: none;\n      }\n.top_header_desktop, .main_header_desktop, .container-fluid{\n    min-height: 40px!important;\n    border: none;\n    padding: 0%;\n}\n .top_bar_name_instance_holder {\n    padding-top: 10px;\n    padding-bottom: 10px;\n    display: inline-block; \n}\n\n\n.top_bar_name_instance_holder .instance_holder,\n.top_bar_name_instance_holder .app_name_holder {\n  /*  padding-left: 15px; */\n    font-size: 14px;\n    font-weight: normal !important;\n    display: inline-block;\n    color: var(--navbar-fg-color);\n}\n.top_bar_name_instance_holder .separator_holder {\n    margin: 0px 10px;\n    color: white; \n    line-height: initial;\n}\n \n.instance_holder {\n    color: var(--navbar-fg-color);\n}\n.top_header_desktop .top_bar_name_instance_holder > div:first-of-type {\n    padding-left: 0px;\n}\n\n.navbar .navbar-nav .nav-item .nav-link {\n    font-size: 14px;  \n    font-size: 1rem;\n    line-height: 22px;\n}\n\n#navbar-root .main_header_desktop {\n   /* box-shadow: 0px 4px 4px rgb(0 0 0 / 25%); */\n    width: 100%;\n}\n\n#navbar-root nav.main_header_desktop  .navbar-nav  .nav-item  a.nav-link:not(.show),\n#navbar-root nav.main_header_desktop .navbar-nav .nav-link a {\n    color: var(--navbar-fg-color) !important;\n    text-decoration: none;\n}\n\n#navbar-root .main_header_desktop  .navbar-nav  .nav-item  .nav-link:hover::before {\n    border-bottom: 5px solid #ffffff !important;\n    color: #fff;\n    content: \"\";\n   /* position: sticky; */\n    bottom: 0;\n    width: 100%;\n    left: 0;\n}\n\n\n\n#navbar-root nav.main_header_desktop .navbar-nav .nav-item.active_menu_dropdown a.nav-link{\n    padding-bottom: 5px;\n    border-bottom: 5px solid #eceef0  !important;\n}\n\n\n#navbar-root nav.main_header_desktop  .navbar-nav  .nav-item:focus  a.nav-link {\n    border-bottom: 5px solid #eceef0  !important;\n}\n\n#navbar-root nav.main_header_desktop .main_header_desktop > .show > a, \n#navbar-root nav.main_header_desktop .main_header_desktop > .show > .dropdown-menu {\n    background-color: #fff;\n    border: none;\n    border-radius: 0px;\n    -webkit-box-shadow: 0 6px 12px rgb(0 0 0 / 18%);\n    margin-top: 0px;\n    box-shadow: 0 6px 12px rgb(0 0 0 / 18%);\n}\n#navbar-root nav.main_header_desktop .main_header_desktop > .show > .dropdown-menu  a {\n    display: block;\n    padding: 3px 20px 3px 0px;\n    clear: both;\n    font-weight: 400;\n    line-height: 1.42857143; \n    font-size: 0.95rem;\n    color: #333 !important;\n}\n\n#navbar-root nav.main_header_desktop .main_header_desktop > .show > .dropdown-menu  .dropdown-item:hover,\n#navbar-root nav.main_header_desktop .main_header_desktop > .show > .dropdown-menu  .dropdown-item.active,\n#navbar-root nav.main_header_desktop .main_header_desktop > .show > .dropdown-menu  .dropdown-item:active {\n    background-color: #e9e9e9;\n}\n\n\n#navbar-root nav.main_header_desktop .main_header_desktop > .show > .dropdown-menu  .dropdown-item:focus{ \n    background-color: #e9e9e9;\n}\n\n.active_menu_item > a::before {\n    width: 0;\n    height: 0;\n    border-top: 5px solid transparent;\n    border-bottom: 5px solid transparent;\n    border-left: 5px solid #d55151;\n    content: '';\n    position: absolute;\n    left: 0;\n    margin-top: 5px;\n    \n}\n\n\n.schema-engine-active-menu  > a::after{\n    content: \"\";\n    display: block;\n    margin: auto;\n    height: 5px;\n    position: relative;\n    width: 0;\n    top: 5px;\n    background: transparent;\n    transition: all 0.5s;\n}  \n\n .schema-engine-active-menu  > a:hover::after,\n .schema-engine-active-menu a::after {\n    width: 100%;\n    background: #fff;\n  }\n  \n .schema-engine-active-menu-dropdown-item:hover,\n .schema-engine-active-menu-dropdown-item {\n    background-color: #e9e9e9 !important;\n } \n\na.active_menu_item {\n    font-weight: bold!important;\n}\n.active_menu_dropdown.show {\n    box-shadow: inset -5px 11px 6px -8px #16243454 !important;\n    background-color: #eceef0;\n}\n\n#navbar-root nav.top_header_desktop .top_header > .show > a,\n #navbar-root nav.main_header_desktop .main_header_desktop > .show > a {\n    box-shadow: inset -5px 11px 6px -8px #16243454 !important;\n    color: #333 !important;\n   /* margin-top: 3px;*/\n}\n\n\n.img-left-logo {\n    min-width: 30px;\n    max-height: 30px;\n    margin-top: 5px;\n    margin-bottom: 5px;\n\n}\n.img-right-logo, .img-right-logo> a {\n    min-width: 45px;\n    max-height: 40px;\n    display: inline-block;\n    padding-top: 5px;\n}\n.img-right-logo-img{\n    min-width: 30px;\n    max-height: 30px;\n}\n.img-left-logo-img {\n    min-width: 30px;\n    max-height: 30px;\n}\n.user_icon {\n    min-width: 20px;\n    max-height: 20px;\n    padding-right: 5px;\n}\n.user_icon.forward_login_icon {\n    min-width: 15px;\n    max-height: 15px;\n}\n/* DESKTOP MEDIA QUERY */\n@media (min-width: 1200px) {\n    .top_header_desktop,\n    .main_header_desktop{\n        min-height: 40px !important;\n        height: 40px !important\n    }\n    #navbar-root + * {\n        padding-top: 81px;\n    }\n}\n.sign-in {  \n    font-weight: normal;\n    color: white !important;\n    padding: 10px 15px;\n    line-height: 20px;\n    text-decoration: none;\n}\n\n#navbar-root {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 1012 !important;  \n    box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);\n}\n\n.ow-position-fixed{\n    position: fixed;\nheight: 60px;\ntop: 80px;\nz-index: 1010;\ndisplay: block;\nmargin-bottom: 84px;\nleft: 4px;\nright: 4px;\nbackground-color: #fff;\n}\n\n/* DESKTOP MEDIA QUERY */\n@media (min-width: 1200px) {\n    #navbar-root + * {\n        padding-top: 81px;\n    }\n}\n/* TABLET MEDIA QUERY */\n@media (min-width: 768px) and (max-width: 1199px) {\n    #navbar-root + * {\n        padding-top: 87px;\n    }\n}\n/* MOBILE MEDIA QUERY */\n@media (max-width: 767px) {\n    #navbar-root + * {\n        padding-top:80px;\n    }\n    #navbar-root nav.main_header_desktop  .navbar-nav  .nav-item.active_menu_dropdown  a.nav-link:before,\n    #navbar-root nav.main_header_desktop  .navbar-nav  .nav-item.active_menu_dropdown  a.nav-link:hover {\n        border-bottom: 0px  !important;\n    }\n    .navbar-nav .nav-link {\n        padding-left: 10px;\n    }\n    #navbar-root nav.main_header_desktop .navbar-nav .nav-item a.nav-link:hover {\n        border-bottom: 0px  !important;\n        background-color: #cccccc57;\n    } \n    #navbar-root nav.main_header_desktop .navbar-nav .active_menu_dropdown.nav-item a.nav-link {\n        background-color: #cccccc57;\n    }\n    .top_bar_name_instance_holder{  padding-top: 5px;}     \n    .top_bar_name_instance_holder .instance_holder, \n    .top_bar_name_instance_holder .app_name_holder {\n        font-size: 12px;\n    }\n    .img-left-logo {\n        min-width: 30px;\n        max-height: 20px;\n        margin-top: 10px;\n        margin-bottom: 0px;\n      }\n      .table-wrapper { \n        padding-top: 0px;\n      }\n      .wrapper {\n        padding-top: 0px !important;\n      }\n      .breadcrumb{\n        padding:5px  0px !important;\n      }\n      .nav-wrapper{\n        margin-bottom: 60px !important;\n      }\n      .mar-120{\n        margin-bottom: 130px !important;\n      }\n      .mar-120-mobile {\n        margin-bottom: 0px !important;\n        margin-top: 120px !important;\n       }\n       \n\n}\n\n/****START WELCOME PAGE****/\n.welcomePage{\n    background: url(\"../../../resources/images/welcome_bgd.png\");\n    background-position: center;\n    background-repeat: no-repeat;\n    vertical-align: -webkit-baseline-middle;\n    background-size: cover;\n    height: 400px;\n    -webkit-box-shadow: -11px 13px 20px -6px rgba(0,0,0,0.15);\n    -moz-box-shadow: -11px 13px 20px -6px rgba(0,0,0,0.15);\n    box-shadow: -11px 13px 20px -6px rgba(0,0,0,0.15);\n    text-align: center;\n    margin-right: auto;\n    margin-left: auto;\n   /* margin-top: calc(50vh - 245px);*/\n    \n    margin-top: 200px;\n}\n.welcomePageCenter{\n    height: 400px;\n    display: table;\n    margin: 0 auto;\n}\n\n.welcomePageRight {\n    background: url(\"../../../resources/images/mock-up.png\");\n    height: 210px;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center center;\n}\n.m-t-20 {\n    margin-top: 20px;\n    height: calc(100vh - 70px);\n}\n\n.welcomePageTitle{\n    color: #ce0008;\n    font-size:44px;\n    font-family: \"MarkBold\", sans-serif;\n}\n.welcomeRightMessage{\n    text-align: center;\n    bottom: 42px;\n    position: relative;\n    margin-left: 45px;\n}\n.welcomePageMessage{\n    color: #10171e;\n    font-size: 20px;\n    margin-bottom: 18px;\n}\n.welcomePageButtonLearn{\n    border: 1px solid #ce0008;\n    border-radius: 0px;\n    color:#ce0008;\n    background: transparent;\n}\n.welcomePageButtonLearn:hover{\n    color: #10171e;\n    background: #fff;\n    border:1px solid #ce0008;\n}\n.btn-icon{\n    width: 30px;\nheight: 30px;\nvertical-align: middle;\ntext-align: center;\ndisplay: inline;  \npadding: .25rem .25rem !important;\n}\n.btn-area {\n    margin: 0;\n    padding: 0 15px;\n}\n.btn_sign_up {\n    color: #0f1f2e;\n    height: 35px;\n  /*  font-size: 16px; */\n    background: #fff;\n    border: 1px solid #0f1f2e;\n    margin-bottom: 17px;\n}\n.btn_sign_up:hover {\n    color: #fff;\n    border: 1px solid #0f1f2e;\n    background: #0f1f2e;\n}\n.btn_sign_up:focus{\n    outline: 0;\n}\n/* .btn-ch a[disabled=disabled] {\n color: red;\n font-weight: bold;\n } */\n.welcomePageButtonSingUp{\n    border: 1px solid #ce0008;\n    border-radius: 0px;\n    color: white;\n    background-color: #ce0008;\n}\n.welcomePageButtonSingUp:hover{\n    color: #10171e;\n}\n.welcomePageContent{\n    vertical-align: middle;\n    display: table-cell;\n    height: 400px;\n}\n.welcomePageContent img{\n    margin: 0px auto;\n}\n\n.text_center_style {\n    font-size: 16px;\n    text-align: center;\n}\n.text_under_mc{\n    font-size: 24px;\n    color:#ce0309;\n    text-align: center;\n}\n.display_inl {\n    display: inline;\n}\n.welcomePowerBy{\n    position: absolute;\n    right: 10px;\n    bottom: 8px;\n    text-align: right\n}\n\n@media (max-width: 767px) {\n    .welcomePage{\n        height: 650px; \n        margin-top: 60px;\n    }\n    .welcomePageContent{\n        height: 250px;\n    }\n}\n/****END WELCOME PAGE****/\n\n/* Login page start */\n.login-wrapper  img {\n    max-width: 100%;\n}\n.img_padding_bottom {\n    padding-bottom: 10px;\n}\n.background-login{\n\tbackground: url(\"../../../resources/images/orbiwise-white-bg.jpg\");\n\t background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    height: calc(100vh - 80px);\n    /* height: 100%; */\n    display: table;\n    table-layout: fixed;\n    width: 100%;\n    overflow: hidden;\n}\n.login-wrapper {\n    margin-top: 4rem;\n}\n.a-link {\n    color: #172434;\n    text-decoration: underline;\n    font-size: 12px;\n}\n\n/* Login page end */\n#user_dropdown_item {\n    margin-right: 5px;\n    font-weight: normal !important;\n}\n.shadow_dropdown .dropdown-toggle::after {\n    vertical-align: .055em;\n}\n.shadow_dropdown>a:hover,\n.shadow_dropdown > .nav-link {\n    color: var(--navbar-fg-color) !important;\n}\n.shadow_dropdown.show {\n    background-color: white!important;\n    box-shadow: inset -5px 11px 6px -8px #16243454 !important;\n    color: #333 !important;\n}\n.shadow_dropdown.show > .nav-link {\n    color: #333 !important;\n}\n\n.shadow_dropdown>a[aria-expanded=\"true\"]:hover {\n    color: black!important;\n}\n.shadow_dropdown .dropdown-menu{\n    margin-top: 0px;\n    border-radius:0px;\n    padding: 0;\n}\n.navbar-expand .navbar-nav .dropdown-menu{\n    min-width: 200px;\n}\n\n.navbar-expand .navbar-nav .shadow_dropdown .dropdown-menu.show .dropdown-item:hover{\n    background-color: #ccc !important;\n}\n.user_icon {\n    min-width: 20px;\n    max-height: 20px;\n    padding-right: 5px;\n}\n.img_user {\n    min-width: 40px;\n    max-height: 40px;\n    margin-right: 5px;\n}\na[aria-expanded=\"true\"] span img[id=\"user_icon2\"] {\n    filter: invert(85%);\n}\n#navbar-root .top_header_desktop .top_header .width_mobile > .dropdown-menu > .dropdown-item {\n    font-size: 0.95rem;\n    line-height: 1.42857143;\n    vertical-align: middle;\n    font-weight: 400;\n    display: table;\n/*    border-top: 1px solid #ccc;   TODO: why is this here?? */\n    padding: .3rem 1rem;\n    color: #000;\n}\n\n\n#navbar-root .top_header_desktop .top_header .width_mobile > .dropdown-menu > .dropdown-item > svg {\n    padding-right: 10px;\n    padding-top: 4px;\n}\n\n#navbar-root .top_header_desktop .top_header .width_mobile > .dropdown-menu > .dropdown-item  svg{    \n    font-size:1.2rem;\n    width: 25px;\n    color: #000;\n}\n\n#navbar-root .top_header_desktop .top_header .width_mobile > .dropdown-menu > .dropdown-item.active,\n#navbar-root .top_header_desktop .top_header .width_mobile > .dropdown-menu > .dropdown-item:active,\n#navbar-root .top_header_desktop .top_header .width_mobile > .dropdown-menu > .dropdown-item:focus {\n    background-color: #e9e9e9 !important;\n}\n\n\n.lang_dropdown > .dropdown-menu > .dropdown-item > svg {\n    color: #000;\n}\n\n.lang_dropdown > .dropdown-menu > .dropdown-item.active,\n.lang_dropdown > .dropdown-menu > .dropdown-item:focus {\n    background-color: #e9e9e9 !important;\n    color: #000 !important;\n}\n\n\n#navbar-root .top_header_desktop .top_header .width_mobile > .dropdown-menu > .dropdown-item:active svg,\n#navbar-root .top_header_desktop .top_header .width_mobile > .dropdown-menu > .dropdown-item:focus svg,\n#navbar-root .top_header_desktop .top_header .width_mobile > .dropdown-menu > .dropdown-item.active svg{\n    color: black;\n}\n\n\n/* ------------------------------------------------------------------------------- *\n *- Schema Modal styles ----------------------------------------------------------- *\n * ------------------------------------------------------------------------------- */\n\n .schema-engine-error-text{\n    color: #dc3545 !important;\n} \n.schema-engine-error-frame{\n    border-color: #dc3545 !important;\n} \n\n\n .schema-engine-header{\n    background-color: transparent;\n    color: #000;\n    border-bottom: none;\n    border-top-left-radius:0;\nborder-top-right-radius: 0;\n}\n\n.schema-engine-footer{\n\n    border-top: none;\n    border-bottom-left-radius:0;\nborder-bottom-right-radius: 0;\n}\n\n.schema-engine-body{\n    /*padding: 0px;*/\n} \n.schema-engine-tabs{\n\n}\n.schema-engine-tabs .schema-tab-list {\n    height: var(--tab-height-default);\n    overflow-y: scroll;\n    flex-wrap: nowrap;\n  }\n  \n  .child-tab-wrapper-impersonated .schema-engine-tabs .schema-tab-list {\n    height: var(--tab-height-impersonated);\n    overflow-y: scroll;\n    flex-wrap: nowrap;\n  }\n\n.schema-engine-tabs .schema-tab-list .nav-link{\n    word-break: break-all;\n}\n\n\n@media only screen and (max-width: 768px) {\n    .schema-engine-tabs .schema-tab-list{\n        height: auto;\n        overflow-x: scroll;\n        overflow-y: unset;\n}\n.schema-detail-page .header {\n    margin: 0px 0px !important;\n}\n.schema-engine-tabs-content {\n    padding: 0px 0px 10px !important;\n}\n}\n.schema-engine-array-container-table tbody tr td {\n    border-right: 0px;\n    border-bottom-width :0px;\n    padding: 0px 4px 0px 0px;\n}\n \n.schema-engine-array-container-table .form-control:disabled,\n.schema-engine-array-container-table .form-control{\n    margin: 0px 0px !important;\n   /* height: 30px !important; */\n}\n\n.schema-engine-array-container-table > :not(:first-child) {\n    border-top: 0px ;\n  }\n \n.schema-tab-list .nav-item a{\n    color: #6e6e6e;\n    background-color: #fff;\n    margin: 0 0rem 0.5rem 0.5rem;\n    border: 1px solid rgba(0, 0, 0, 0.175);\n    border-radius: 4px;  \n    box-shadow: 0 2px 6px 0 rgba(67,89,113,.12);\n    width: auto;\n}\n@media only screen and (max-width: 768px) {\n    .schema-tab-list .nav-item a{ \n        width: max-content;\n    }\n}\n\n.schema-engine-tabs .schema-tab-list .nav-item .nav-link.active {  \n    color: #fff;\n    background-color: #182535;\n    box-shadow: 1px 2px 3px 0px #0000;\n   /* margin-right: 0px;\n    border-top-right-radius: 0px;\n    border-bottom-right-radius: 0px;\n    font-weight: bold;888*/\n}\n\n.schema-engine-tabs .schema-tab-list  .nav-item .nav-link:hover, .schema-engine-tabs .schema-tab-list .nav-item .nav-link:focus  {\n    text-decoration: none;\n    color: white;\n    background-color: #182535;\n}\n.ow-dashboard {\n        min-height: calc(100vh - 80px) !important;\n}\n.ow-dashboard .schema-engine-tabs-content{\n    height: calc(100vh - 140px) !important;\n}\n\n.schema-engine-tabs-content{\n    padding: 0px 10px 10px;\n    width: 100%;\n    height: var(--tab-height-default);\n    overflow-y: scroll;\n   \n}\n\n.child-table-wrapper-impersonated .schema-engine-tabs-content{\n    padding: 0px 10px 10px;\n    width: 100%;\n    height: var(--tab-height-impersonated);\n    overflow-y: scroll;\n}\n\n\n.child-tab-wrapper .schema-detail-page .body{\n    height: var(--tab-height-default) !important;\n}\n\n.child-tab-wrapper-impersonated .schema-detail-page .body{\n    height: var(--tab-height-impersonated) !important;\n}   \n\n\n\n\n.ow-dashboard .schema-detail-page .body{\n\n    height: calc(100vh - 140px) !important;\n}\n.ow-dashboard.impersonated .schema-detail-page .body{   \n    height: calc(100vh - 180px) !important;\n}\n\n@media only screen and (max-width: 768px) {\n    .child-tab-wrapper.ow-dashboard  .schema-detail-page .body{\n     overflow:overlay;\n         height:auto;\n     }\n     .ow-dashboard .schema-engine-tabs-content {\n         height: calc(100svh - 220px);\n     }\n     .child-tab-wrapper-impersonated .schema-detail-page .body {\n        height: calc(100svh - 250px) !important;\n    }\n    \n }\n\n.schema-engine-card {\n    width: calc(100% - 0.6rem);\n    margin: 0.3rem 0.3rem 0.3em 0.3rem;\n    box-shadow: 0 2px 6px 0 rgba(67,89,113,.12);\n}\n.schema-engine-card .card-header{\n    font-weight: bold !important;\n    border-bottom: 0px;\n    font-size: 1.1rem;\n    background-color: #fff;\n}\n\n.schema-engine-card .bg-secondary > .card-header{\n    background-color: #6c757d ;\n}\n\n\n.schema-engine-card-action-buttons {\n    display: flex;\n    flex-direction: row;\n}\n\n.schema-engine-card-action-buttons > * {\n    margin-left: 5px;\n}\n\n.schema-engine-card-top-right-control {\n    position: absolute;\n    top: 8px; /* Adjust as needed */\n    right: 0px; /* Adjust as needed */\n    z-index: 1;\n    text-align: right;\n}\n\n.schema-engine-dashboard-card .schema-engine-card-top-right-control .dropdown-toggle::after{\n    display: none;\n}\n\n\n.schema-engine-card  .card-header:first-child {\n    border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);\n}\n\n.schema-engine-card-width-column1 {\n    /* OBSOLETE - delete: width: calc(100%); */\n}\n.schema-engine-card-width-column2 {\n    /*  OBSOLETE - delete: width: calc(100% / 2 - 1rem); */\n}\n.schema-engine-card-width-column3 {\n    /*  OBSOLETE - delete: width: calc(100% / 1 - 1rem); */\n}\n\n.schema-engine-card-100-percent {\n    width: calc(100% - 0.6rem);\n    height: calc(100% - 0.6rem);\n}\n\n.schema-engine-card-100-percent .card-body{\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    min-height: 0px;\n}\n\n\n.custom-dot-list-style{\n    margin-top: 20px;\n}\n/* Medium devices (landscape tablets, 768px and up) */\n@media only screen and  (max-width: 999px){\n\n    .schema-engine-card { \n        margin: 0 0rem 0.5rem 0;\n    }\n\n    .col-form-label{\n        padding-top: 0% !important;\n    }\n    .navbar-collapse {\n        max-height: 300px;\n        overflow-y: scroll;\n    }\n\n}\n\n\n\n/* Extra large devices (large laptops and desktops, 1200px and up) */\n@media only screen and (min-width: 1000px) { \n\n}\n.schema-engine-dashboard-card {\n    border: 1px solid #d6d6d6;\n    box-shadow: rgba(67, 89, 113, 0.12) 0px 2px 6px 0px;\n    overflow: visible !important;\n}\n.schema-engine-dashboard-card .card-header .schema-engine-card-header-title{\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n}\n.schema-engine-dashboard-card .card-header{\n    background-color: transparent !important;\n    border-bottom: 0px;\n    font-size: 1rem;\n    color: #666; \n}\n.schema-engine-dashboard-card .card-header .schema-engine-card-action-buttons button{\n    padding-right: 0px;\n    padding-left: 0px;\n}\n.schema-engine-dashboard-card .card-header .schema-engine-card-action-buttons .dropdown-toggle::after{\n    display: none;\n}\n.__schema-engine-dashboard-card .card-header i{\n    font-size: 1.8rem;\n    color: #cc4748;\n}\n.schema-engine-dashboard-card .card-body{\npadding: 0.2rem 0.5rem; \noverflow-x: hidden;\noverflow-y: auto;\n}\n.schema-engine-dashboard-card-layout-2\n{\n    height: 100%;\n    width: 100%;\n    overflow-block: clip;\n overflow: hidden;\n}\n.schema-engine-dashboard-card-layout-3\n{\n    height: 100%;\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    justify-content:space-between;\n    align-items: center;\n}\n.schema-engine-dashboard-status-elem  {\n    font-size: 1rem;\n    text-align: center;\n}\n.schema-engine-dashboard-status-elem.schema-engine-dashboard-default-variant{\n    display: flex; \n    flex-wrap: wrap;\n    justify-content:center;\n    height: 100%;\n}\n.schema-engine-dashboard-status-elem .schema-engine-dashboard-status-elem-value{\n    font-size: 2.5rem;\n}\n.schema-engine-dashboard-status-elem .schema-engine-dashboard-status-elem-description{\n    color: #99A1B7;\n}\n/* ------------------------------------------------------------------------------- *\n *- pagination style start ----------------------------------------------------------- *\n * ------------------------------------------------------------------------------- */\n .page-link{\n    color: #212529;  \n    padding: .2rem 0rem;\n    border-color: #000;\n }\n\n .page-link:hover {\n    z-index: 2;\n    color: #fff;\n    background-color: #212529;\n    border-color: #000;\n }\n.page-item.active .page-link {\n    z-index: 3;\n    color: #fff;\n    background-color: #212529;\n    border-color: #212529;\n}\n.page-item:disabled  .page-link {\n    border-color: #dee2e6 !important;\n}\n.page-item.disabled:hover{\n    cursor: not-allowed !important;\n}\n\n.page-item:last-child .page-link,\n.page-item:first-child .page-link {\n    \n}\n.pagination{\n\n  margin-bottom: 5px;\n}\n/*.pagination div{    \nborder: 1px solid #000;\n}*/\n\n.pagination .previous, .pagination .next {\n    cursor: pointer;\nposition: relative;\ndisplay: block;\ncolor: #212529;\nborder: 1px solid #000;\ntext-decoration: none;\nbackground-color: #fff;\npadding: .1rem .75rem;\n}\n.pagination .previous{\n    border-top-left-radius:.25rem;\n    border-bottom-left-radius:.25rem ;\n}\n\n.pagination .next{\n    border-top-right-radius:.25rem ;\n    border-bottom-right-radius:.25rem ;\n}\n.showing-data .form-select{\n    padding: .275rem 2.25rem .175rem .75rem;\n    border: 1px solid #000;\n\n}\n/*-----------------------------------------------------------------------*/\n/*----------------------- breadcrumb style Start ------------------------*/\n/*-----------------------------------------------------------------------*/\n\n\n.breadcrumb {\n\t/*centering*/\n\tdisplay: inline-block;\n    /*margin-bottom: 10px;\n\tbox-shadow: 0 0 15px 1px rgba(0, 0, 0, 0.35);\n\toverflow: hidden;\n\tborder-radius: 5px;*/\n    padding: 0px 0px !important;\n    margin-bottom:0px !important;\n\t/*Lets add the numbers for each link using CSS counters. flag is the name of the counter. to be defined using counter-reset in the parent element of the links*/\n\t/*counter-reset: flag; */\n}\n\n.breadcrumb div {\n\ttext-decoration: none;\n\toutline: none;\n\tdisplay: block;\n\tfloat: left;\n\tfont-size: 18px;\n    font-weight: 600;\n\tline-height: 30px;\n\tcolor: #000;\n\t/*need more margin on the left of links to accomodate the numbers*/\n\tpadding: 0 10px ;\n/*\tbackground: #666;\n\tbackground: linear-gradient(#666, #333);*/\n\tposition: relative; \n}\n/*since the first link does not have a triangle before it we can reduce the left padding to make it look consistent with other links*/\n.breadcrumb > div:first-child {\n\tpadding-left: 10px;\n/*\tborder-radius: 5px 0 0 5px; /*to match with the parents radius*/ \n}\n.breadcrumb div:first-child:before {\n\tleft: 14px;\n}\n.breadcrumb > div:last-child {\n\tborder-radius: 0 5px 5px 0; /*this was to prevent glitches on hover*/\n\tpadding-right: 10px;\n}\n.breadcrumb > div small{\n    color: #7a7a7a;\n    font-size: small;\n    margin-left: 5px;\n    font-weight: normal;\n}\n\n/*hover/active styles*/\n/*.breadcrumb div.active, .breadcrumb div:hover{\n\t/*background: #333;\n\tbackground: linear-gradient(#333, #000);\n} \n.breadcrumb div.active:after, .breadcrumb div:hover:after {\n\tbackground: #333;\n\tbackground: linear-gradient(135deg, #333, #000);\n}*/\n\n/*adding the arrows for the breadcrumbs using rotated pseudo elements*/\n.breadcrumb > div.cursor-pointer::after {\n\tcontent: '>';\n\tposition: absolute;\n\ttop: 0; \n    right: -4px; /*half of squares length*/\n\t/*same dimension as the line-height of .breadcrumb a */\n\n/* width: 28px;\nheight: 30px; */\n\t/*as you see the rotated square takes a larger height. which makes it tough to position it properly. So we are going to scale it down so that the diagonals become equal to the line-height of the link. We scale it to 70.7% because if square's: \n\tlength = 1; diagonal = (1^2 + 1^2)^0.5 = 1.414 (pythagoras theorem)\n\tif diagonal required = 1; length = 1/1.414 = 0.707*/\n\n/*    transform: scale(0.707) rotate(45deg);\n\t/*we need to prevent the arrows from getting buried under the next link*/\n/*\tz-index: 1;\n\t/*background same as links but the gradient will be rotated to compensate with the transform applied*/\n/*\tbackground: #666;\n\tbackground: linear-gradient(135deg, #666, #333);\n\t/*stylish arrow design using box shadow*/\n/*\tbox-shadow: \n\t\t2px -2px 0 2px rgba(0, 0, 0, 0.4), \n\t\t3px -3px 0 2px rgba(255, 255, 255, 0.1);\n\t/*\n\t\t5px - for rounded arrows and \n\t\t50px - to prevent hover glitches on the border created using shadows*/\n        \n /*  box-shadow:  2px -2px 0 2px #ebf3f1;\n\tborder-radius: 0 5px 0 50px;*/\n}\n/*we dont need an arrow after the last link*/\n.breadcrumb > div.cursor-pointer:last-child::after {\n\tcontent: none !important;\n}\n\n/*we will use the :before element to show numbers*/\n/*.breadcrumb a:before {\n\t/*content: counter(flag);\n\tcounter-increment: flag;*/\n\t/*some styles now*/\n\t/*border-radius: 100%;\n\twidth: 20px;\n\theight: 20px;\n\tline-height: 20px;\n\tmargin: 8px 0;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 30px;\n\tbackground: #444;\n\tbackground: linear-gradient(#444, #222);\n\tfont-weight: bold;\n}*/\n\n\n.flat a, .flat a:after {\n\tbackground: white;\n\tcolor: black;\n\ttransition: all 0.5s;\n}\n.flat a:before {\n\tbackground: white;\n\tbox-shadow: 0 0 0 1px #ccc;\n}\n.flat a:hover, .flat a.active, \n.flat a:hover:after, .flat a.active:after{\n\tbackground: #9EEB62;\n}\n/*-----------------------------------------------------------------------*/\n/*----------------------- breadcrumb style end ------------------------*/\n/*-----------------------------------------------------------------------*/\n\n.copy-device{\n    cursor: pointer;\n    color: #868888;\n}\n.copy-device:hover{    \n    color: #1e6f8d;\n}\n\n.NetworkMapWarpper {\n    position: absolute;\n    flex-direction: column;\n    width: 350px;\n    height: 100%;\n    top: 0px;\n    left: 0px;\n    z-index: 999;\n    border:1px solid #000;\n    display: flex;\n}\n\n.ow-app-map-left-sliding-panel {\n    position : absolute;\n    width: 350px;\n    height: 100%;\n    top: 0px;\n    left: 0px;\n    display: flex;\n    flex-direction : row;\n    z-index: 999;\n    border:0px solid;\n}\n\n.ow-app-map-left-sliding-panel .ow-app-map-left-sliding-panel-inner {\n    position :relative;\n    top:0;\n    left:0;\n    width: 300px;\n    height:100%;\n    display: flex;\n    flex-direction : column;    \n    background-color: rgb(255, 255, 255);\n    padding-top: 10px;\n\n}\n\n\n\n#NetworkMap {\n    width: 300px;\n    height: 100%;\n    top: 0px;\n    left: 0px;\n    display: flex;\n    flex-direction: column;\n    z-index: 999;\n    border: 1px none;\n    padding: 10px;\n    background-clip: padding-box;\n    /*background-color: rgba(250,250,250, 0.8);*/\n    box-shadow:2px 3px 5px #80808096;\n}\n\n#NetworkMap .has-success .form-control,\n#NetworkMap .has-success .input-group-addon {\n    border-color: #78b97f;\n}\n\n#NetworkMap .search_input_wrapper {\n    /*z-index: 409;\n    position: absolute;\n    left: 30px;\n    top: 105px;\n    width: 225px;\n    box-shadow: -6px 6px 5px #80808096;*/\n    border-radius: 5px;\n    margin-bottom:10px; \n    padding:0px 10px\n    /*box-shadow: -6px 6px 5px #80808096;*/\n}\n\n#NetworkMap .search_input_wrapper > div {\n    margin-bottom: 0;\n    border-radius: 5px;\n}\n\n#NetworkMap .search_input_wrapper > div .input-group-addon {\n    background: rgba(250, 250, 250, 0.8);\n    color: #000;\n}\n\n#NetworkMap .search_input_wrapper > div.has-success .input-group-addon {\n    color: #333;\n}\n\n#NetworkMap .search_input_wrapper > div input {\n      /* border-left: none;*/\n    background: rgba(250, 250, 250, 0.8);\n}\n\n#NetworkMap .custom_control {\n    /*position: absolute;\n    left: 30px;\n    bottom: 20px;\n    z-index: 409;\n    width: 225px;*/\n    box-shadow: -6px 6px 5px #80808096;\n    background-color: rgba(250,250,250, 0.8);\n    padding: 0px 0 0 10px;\n    border-radius: 5px;\n    border: 1px solid #ddd;\n    color: #333;\n    font-size: 14px;\n    background-clip: padding-box;\n    margin-bottom: 20px;\n}\n\n\n#NetworkMap .device_list {\n    /* position: absolute;\n    left: 30px;\n    bottom: 20px;\n    z-index: 409;*/\n    /*box-shadow: -6px 6px 5px #80808096;*/\n    height: 100%;\n    background-color: rgba(250,250,250, 0.8);\n    /*padding: 0px 0 0 10px;*/\n    /*border-radius: 5px;*/\n    /*border: 1px solid #ddd;*/\n    color: #333;\n    font-weight: 700;\n    /*background-clip: padding-box;*/\n    overflow: auto;\n    /* margin-bottom: 10px; */\n    padding:0px 0px\n}\n\n/*\n#NetworkMap .custom_control > .checkbox {\n    margin-top: 5px;\n    margin-bottom: 5px;\n}*/\n\n#NetworkMap .device_list .table{\n    margin-bottom: 0px;\n}\n\n#NetworkMap .saveButton {\n    position: absolute;    \n    right: -40px;\n    bottom: 10px;\n    width: 30px;\n    height: 30px;\n    z-index: 409;\n    padding: 0px;\n}\n\n#NetworkMap .card{\n    background-color: transparent !important;\n}\n\n#NetworkMap .card .card-body {\n    padding: 0px;\n}\n\n#NetworkMap #map-device-list-panel {\n    z-index: 409;\n   /* width: 225px;*/\n    top: 150px;\n    left: 30px;\n}\n#NetworkMap #map-device-list-panel .table>tbody>tr>td {\n    background-color: transparent !important;\n    padding: 4px 8px;\n    font-weight: normal;\n}\n\n#NetworkMap #map-device-list-panel .no-position > td {\n    opacity: 0.5;\n    padding: 8px;\n    background-color: transparent !important;\n}\n\n#NetworkMap #map-device-list-panel tr > td #gateway_icon.green_icon {\n    color: #008000;\n}\n\n#NetworkMap #map-device-list-panel tr > td #gateway_icon.red_icon {\n    color: #ff0000;\n}\n\n#NetworkMap #map-device-list-panel .no-position #no_position_icon {\n    width: 17px;\n    float: right;\n    position: relative;\n    right: 3px;\n    top: 2px;\n}\n\n\n#NetworkMap .app-side-panel-tab-container {\n    position: absolute;\n    width: 300px;\n    height: 100%;\n    top:0;\n    left:0;\n    display: flex;\n    flex-direction: column;\n    z-index: 999;\n    padding:10px 0px 0px;\n    background-color: #FFFFFF;\n}\n\n\n#NetworkMap .app-side-panel-tab-container .tab {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n  /*  border-bottom: 1px solid #000;\n    margin-bottom: 20px; */\n}\n\n#NetworkMap .app-side-panel-tab-container .tab {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    margin-bottom: 10px;\n    flex-grow: initial;\n}\n\n#NetworkMap .app-side-panel-tab-container .tab .network-map-tab {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    border-bottom: 1px solid #ccc;\n    /*  margin-bottom: 20px; */\n    flex-grow: initial;\n    padding-bottom: 10px;\n    width:100%;\n}\n#NetworkMap .app-side-panel-tab-container .tab .network-map-tab:hover{\n    cursor: pointer;\n}\n\n#NetworkMap .app-side-panel-tab-container .tab .network-map-tab.active {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    border-bottom: 2px solid #000;\n  /*  margin-bottom: 20px; */\n    flex-grow: initial;\n    font-weight: 700;\n    width:100%;\n}\n\n.ow-nst-map-left-sliding-panel .slide-button .btn-sm ,\n.ow-app-map-left-sliding-panel .slide-button .btn-sm{\n    border-top-left-radius: 0px !important;\n    border-bottom-left-radius: 0px !important;\n}\n\n.ow-app-map-left-sliding-panel .slide-button {\nz-index: 999;\n}\n.ow-app-map-left-sliding-panel .slide-button #slide-button {\nbox-shadow:2px 3px 5px #80808096;\n}\n\n.confirm-dialog-title{\n    font-size: 1rem;\n   /* font-weight: 700; */\n    margin-bottom: 0rem;\n}\n\n.confirm-dialog-description {\n    display: block;  \n    word-wrap: break-word;\n    overflow-wrap: break-word;\n    margin-top: 10px;  \n}\n\n.schema-detail-page,\n#schema-detail-page-body {\n   /* background: #FFFFFF 0% 0% no-repeat padding-box;\n    box-shadow: 0px 2px 10px #0000001A;*/\n    opacity: 1;\n    display: flex;\n    flex-direction: column;\n}\n\n.schema-detail-page .header {\n    display: flex;\n    flex-direction: row;\n    padding: 10px;\n    justify-content: center;\n    align-items: flex-start;\n    /* ---------- style for floating header ----------- */\n    margin:0px 10px; \n    position: initial;\nheight: 60px;\ntop: 140px;\nz-index: 1010;\ndisplay: block;\nmargin-bottom: 0px;\nleft: 0px;\nright: 0px;\n/*background-color: #fff;*/\n}\n\n.schema-detail-page .header .breadcrumb {\n    display: flex;\n    flex:1;\n    justify-content: start;\n    align-items: center;\n    padding-left: 0px;\n}\n.schema-detail-page .header .breadcrumb div:first-child {\n    padding-left: 0px;\n}\n\n.schema-detail-page .header .buttons {\n    display: flex;\n    flex:1;\n    justify-content: end;\n    align-items: center;\n}\n\n.schema-detail-page .header .tabs {\n    display: flex;\n    flex:1;\n    justify-content: center;\n    align-items: center;\n}\n\n.schema-detail-page .body {\n    /* display: flex; */\n    flex-direction: row;\n    margin-top: 0px;\n    height: calc(100vh - 150px);\n    overflow-y: scroll;\n    overflow-x: clip;           /* FIXME: added to avoid horizontal scrollbar on all schema engine views */\n}\n\n.child-tab-wrapper-impersonated .schema-detail-page .body {\n    flex-direction: row;\n    margin-top: 0px;\n    max-height: var(--tab-height-impersonated);\n    scrollbar-gutter: stable both-edges !important;\n    overflow-y: scroll;\n    overflow-x: clip;           /* FIXME: added to avoid horizontal scrollbar on all schema engine views */\n}\n\n.primary-tabs .btn{\n    border-radius: 0px;\n    color: #848484;\n}\n\n.primary-tabs .btn.active {\n    border: 0px;\n    border-bottom: 2px solid #000;\n    color: #000;\n}\n.ow-map-search-filter.css-b62m3t-container .css-1s2u09g-control {\n    background-color: hsla(0, 0%, 0%, 0.53);\n    border-color: hsl(0, 0%, 48.2%);\n}\n.ow-map-search-filter.css-b62m3t-container .css-1s2u09g-control .css-1d8n9bt .css-14el2xx-placeholder{\n    color:#fff !important;\n}\n.ow-map-search-filter.css-b62m3t-container .css-1s2u09g-control .css-319lph-ValueContainer .css-qc6sy-singleValue {\n    color: hsl(0, 0%, 100%);\n}\n.ow-map-search-filter.css-b62m3t-container .css-1s2u09g-control .css-319lph-ValueContainer .css-14el2xx-placeholder {\n    color: hsl(0, 0%, 100%);\n}\n.ow-map-search-filter.css-b62m3t-container .css-1s2u09g-control .css-319lph-ValueContainer .css-6j8wv5-Input {\n    color: hsl(0, 0%, 100%);\n}\n.ow-profile_uuid {\n    text-transform: uppercase;\n    font-family: monospace;\n}\n\n.ow-profile_uuid {\n    text-transform: uppercase;\n    font-family: monospace;\n}\n\n.font-monospace {\n    text-transform: uppercase;\n    font-family: monospace;\n}\n\n.ow-react-select-custom [class*=\"container\"] [class*=\"control\"] {\n    border-color: #dee2e6;\n}\n\n.ow-react-select-custom [class*=\"container\"] [class*=\"control\"] > div { \n    min-height: 30px !important;\n    overflow: overlay;\n}\n\n.ow-react-select-custom [class*=\"container\"] [class*=\"control\"] > div > div { \n    margin: 0px !important;\n    padding-bottom: 0px !important\n}\n\n.ow-react-select-custom [class*=\"container\"] [class*=\"control\"] > div:nth-child(2) > div {\n    padding: 0 8px;\n}\n\n\n.ob-data-table-main-container .css-b62m3t-container .css-t3ipsp-control{\n    border-color: #000;\n    min-height: 30px !important;\n    max-height: 30px !important;\n}\n.css-b62m3t-container .css-13cymwt-control{\n    \n    min-height: 30px;\n}\n\n.css-b62m3t-container .css-t3ipsp-control{\n    min-height: 30px;\n}\n\n.css-b62m3t-container .css-t3ipsp-control:hover{\n    border-color: #000 !important;\n}\n.css-b62m3t-container .css-t3ipsp-control:focus {\n    outline: none;\n}\n\n.css-b62m3t-container .css-13cymwt-control .css-1fdsijx-ValueContainer .css-qbdosj-Input{\n    margin: 0px 2px;\n}\n\n\n.css-b62m3t-container .css-t3ipsp-control .css-1fdsijx-ValueContainer .css-qbdosj-Input{\n    margin: 0px 2px;\n}\n\n\n.css-b62m3t-container.has-error .css-13cymwt-control {\n\n  border-color: #dc3545 !important;\n}\n.css-b62m3t-container.has-error .css-13cymwt-control .css-1fdsijx-ValueContainer  .css-1jqq78o-placeholder {\n    color: #dc3545;\n}\n\n.css-b62m3t-container .css-8aqfg3-menu .css-qr46ko > div:hover, \n.css-b62m3t-container .css-8aqfg3-menu .css-qr46ko > div:focus {\n    background-color:#afafaf;\n}\n\n.css-b62m3t-container .css-8aqfg3-menu .css-qr46ko > div:active{\n     background-color: #000 !important;\n}\n\n.css-b62m3t-container .css-1te58xy-menu .css-drjxwl .css-jh5fab-option{\n    font-size: 0.9rem !important;\n}\n.css-b62m3t-container  .css-1nmdiq5-menu{\n    min-width: 250px;\n}\n\n/*  ::::::::::::::::::::::::::::::::::::::::::::::::::: */\n/*  :::::::::::::::    NST Style   :::::::::::::::::::: */\n/*  ::::::::::::::::::::::::::::::::::::::::::::::::::: */\n.ow-nst-server-status-info span.badge {\n    min-width: 180px;    \n    border-radius: 25rem !important;\n}\n\n.ow-nst-server-status-info .ow-nst-server-status-info-normal {\n\n    background-color: #dff0d8;\n    background-color: #777777;\n    color: #fff;\n}\n.ow-nst-server-status-info-ok {\n    background-color: #dff0d8;\n    border-color: #d6e9c6;\n    color: #3c763d;\n}\n.ow-nst-server-status-info-warning {\n    background-color: #f2e4c1;\n    border-color: #f2cf82;\n    color: #e49626;\n}\n.ow-nst-server-status-info-critical {\n    background-color: #f2dede;\n    border-color: #ebccd1;\n    color: #a94442;\n}\n.page-wrapper {\n    width: 100%;\n    background: #FFFFFF 0% 0% no-repeat padding-box;\n    padding-top: 10px;\n}\n.schema-engine-array-accordian-container .schema-engine-array-accordion-element-object .accordion-header .accordion-button{\n    color: #000 !important;\n    background-color: #ebebeb;\n}\n.schema-engine-array-accordian-container .schema-engine-array-accordion-element-object h2{    \n    margin-top: 0px !important;\n    font-size: 1.2rem;\n    margin-bottom: 0px !important;\n    font-weight: 600;\n}\n.schema-engine-array-accordian-container .schema-engine-array-accordion-element-object hr.schema-engine-separator-hr{    \n    margin: 5px 0px;\n}\n.schema-engine-dropdown-no-frame {\n    border: none;\n}\n\n/* these styles are for the schema engine object container */\n.schema-engine-object-container .schema-engine-object-container-item .accordion-header .accordion-button{\n    color: #000 !important;\n    background-color: #ebebeb;\n}\n\n.schema-engine-object-container .schema-engine-object-container-item h2{    \n    margin-top: 0px !important;\n    font-size: 1.2rem;\n    margin-bottom: 0px !important;\n    font-weight: 600;\n\n}\n.schema-engine-object-container .schema-engine-object-container-item hr.schema-engine-separator-hr{    \n    margin: 5px 0px;\n}\n\n\n\n\n\n/*change the scrollbars width */\n/* width */\n::-webkit-scrollbar {\n    width: 5px;\n    height: 5px;\n  }\n  \n  /* Track */\n  ::-webkit-scrollbar-track {\n    background: #f1f1f1; \n  }\n   \n  /* Handle */\n  ::-webkit-scrollbar-thumb {\n    background: #888; \n  }\n  \n  /* Handle on hover */\n  ::-webkit-scrollbar-thumb:hover {\n    background: #555; \n  }\n.ow-nst-wrapper .nav-wrapper {\n    margin-bottom: 80px;\n}\n\n.ow-nst-wrapper .mar-120 {\n    margin-bottom: 120px !important;\n}\n\n.ow-nst-wrapper .mar-120-mobile {\n    margin-bottom: 0px !important;\n    margin-top: 120px !important;\n}\n.ow-nst-map-left-sliding-panel{\n    position : absolute;\n    width: 460px;\n    height: 100%;\n    top: 0px;\n    left: 0px;\n    display: flex;\n    flex-direction : row;\n    z-index: 999;\n}\n\n.ow-nst-map-left-sliding-panel-mobile{\n    width: 420px !important;   \n}\n\n.ow-nst-map-left-sliding-panel-mobile   .ow-nst-map-left-sliding-panel-inner-mobile{\n    width: 85% !important; \n}\n\n.ow-nst-map-left-sliding-panel   .ow-nst-map-left-sliding-panel-inner{\n    position :relative;\n    top:0;\n    left:0;\n    width: 440px;\n    height:100%;\n    display: flex;\n    flex-direction : column;    \n    background-color: rgb(255, 255, 255);\n    padding-top: 10px;\n}\n\n/*col-md-12 css-b62m3t-container*/\n\n.ow-nst-map-left-sliding-panel .ow-nst-network_map-id{\n    font-family: monospace;\n}\n\n.ow-nst-map-gateways-action {\n    color: #404040;\n  /*  margin: 0px 5px; \n    font-size: 1.2rem !important;\n\n    margin: 2px 2px 2px 2px;\n    font-size: 1rem !important;*/\n\n}\n\n.nst-map-tag-select {\n    z-index:9999 !important;\n    \n}\n \n.ow-nst-map-gateways-alarm .badge{\n    border-radius: 50rem !important;\n    border: 0px !important;\n    font-weight: 700;\n    line-height: 1;\n    width: 15px;\n    height: 15px;\n    color: #fff;\n    margin: 0px;\n    padding: 0.35em 0.35em;\n    font-size: .60em !important;\n    top: 2px;\n    left: 15px;\n}\n\n.css-b62m3t-container{\n    z-index: inherit;\n    position:relative !important;\n    width: 100%;\n}\n\n.ow-nst-map-left-sliding-panel .ow-nst-map-left-sliding-panel-inner .search_input_wrapper .css-b62m3t-container .css-1s2u09g-control{\n    min-height: 38px;\n}\n.ow-nst-map-left-sliding-panel .ow-nst-map-left-sliding-panel-inner .search_input_wrapper .css-b62m3t-container .css-1pahdxg-control{\n    min-height: 38px;\n}\n \n.ow-nst-map-left-sliding-panel .ow-nst-map-left-sliding-panel-inner .search_input_wrapper .css-b62m3t-container .css-1s2u09g-control .css-319lph-ValueContainer{\n    padding: 0px 8px;\n}\n\n.ow-nst-map-left-sliding-panel .ow-nst-map-left-sliding-panel-inner .search_input_wrapper .css-b62m3t-container .css-1pahdxg-control .css-319lph-ValueContainer{\n    padding: 0px 8px;\n}\n\n.ow-nst-map-left-sliding-panel .ow-nst-map-left-sliding-panel-inner .search_input_wrapper .css-b62m3t-container .css-1s2u09g-control .css-319lph-ValueContainer .css-6j8wv5-Input{\n    margin: 0px;\n}\n  \n.ow-nst-map-left-sliding-panel .ow-nst-map-left-sliding-panel-inner .search_input_wrapper .css-b62m3t-container .css-1s2u09g-control .css-g1d714-ValueContainer {\n    padding: 0px 8px;\n}\n\n.ow-nst-map-left-sliding-panel .ow-nst-map-left-sliding-panel-inner .search_input_wrapper .css-b62m3t-container .css-1s2u09g-control .css-1hb7zxy-IndicatorsContainer .css-tlfecz-indicatorContainer {\n    padding:0px 8px;\n}\n.ow-nst-map-left-sliding-panel .ow-nst-map-left-sliding-panel-inner .search_input_wrapper .css-b62m3t-container .css-1pahdxg-control .css-1hb7zxy-IndicatorsContainer .css-1gtu0rj-indicatorContainer {\n    padding:0px 8px;\n}\n.uppercase{\n    text-transform: uppercase;\n}\n\n\n#extra-search-box [class*=\"container\"]  [class*=\"control\"] {\n    min-height: 30px;\n    color: #000 !important;\n}\n\n#extra-search-box [class*=\"container\"]  [class*=\"menu\"] {\n    z-index: 1100 !important;\n}\n\n#extra-search-box [class*=\"container\"]  [class*=\"control\"]  [class*=\"ValueContainer\"] {\n    padding: 0px 8px;\n    overflow: auto;\n}\n\n\n#extra-search-box  [class*=\"container\"]  [class*=\"control\"]  [class*=\"ValueContainer\"]  [class*=\"Input\"]{\n    margin: 0px;\n    padding-bottom: 0px;\n    padding-top: 0px;\n}\n\n#extra-search-box [class*=\"container\"]  [class*=\"control\"] [class*=\"IndicatorsContainer\"]  [class*=\"indicatorContainer\"] {\n    padding: 0px 8px;\n}\n\n\n.ow-status .form-check {\n    margin-right: 0rem;\n}\n\n.ow-status .form-check .form-check-input:focus {\n    border-color: inherit;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n  }\n.ow-status .form-check .form-check-input[type=\"checkbox\"] {\n    border-radius: 25em;\n    margin-top: .15em;\n  }\n  .ow-status .form-check .form-check-input{\n    border: 2px solid rgba(0,0,0,.25);\n  }\n\n  .ow-status .form-check.major_issue .form-check-input{\n    border-color: #d80606;\n  }\n.ow-status .form-check.major_issue .form-check-input:checked {\n    background-color: #d80606;\n    border-color: #d80606;\n  }\n  .ow-status .form-check.never_seen .form-check-input{    \n    border-color: #000000;\n  }\n   .ow-status .form-check.never_seen .form-check-input:checked {\n    background-color: #000000;\n    border-color: #000000;\n  }\n  .ow-status .form-check.ok .form-check-input{    \n    border-color: #13b827;\n  }\n  .ow-status .form-check.ok .form-check-input:checked {\n    background-color: #13b827;\n    border-color: #13b827;\n  }\n  .ow-carousel .carousel-container .card .card-footer ul{\n    padding-left: 0px;\n    list-style: none;\n  }\n  .ow-carousel .carousel-container .card .card-footer ul li{\n    text-align: center;\n    padding: 5px 0px;\n    border-bottom: 1px solid #ccc;\n  }\n  .ow-carousel .carousel-container .card .card-footer ul li:last-child{\n    border-bottom: 0px;\n  }\n.ow-device-profile-image{\n    height:    revert-layer !important;\n \n}\n\n  .slide-button {\n    width: 50px;\n    height: 100%;\n    padding-top: 10px;\n    background-color: transparent;\n    border:0px solid;\n    \n}\n\n.single-page-header {\n    display:flex;\n    flex-direction: row;\n   max-height: 60px !important;\n}\n\n.col-wise {\n    display:flex;\n    flex-direction: 'row';\n    align-items:center;\n}\n\n.col-vertical {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n}\n\n.col-vertical.col-vertical-column {\n    display:flex;\n    flex-shrink: inherit;\n}\n\n\n/* #main {\n    width: 350px;\n    height: 500px;\n    border: 1px solid #c3c3c3;\n    display: flex;\n    flex-direction:column;\n  }\n  \n  #main .shrink {\n    flex-shrink: 1;\n    flex-basis: 50px;\n    \n  }\n  \n  #main .grow {\n    flex-grow: 1;\n    flex-basis: 100px;\n  } */\n  @media only screen and (max-width: 530px) {\n    .table-wrapper {\n        height: calc(100vh - 250px) !important;\n        height: calc(100dvh - 250px) !important;\n        height: calc(100svh - 250px) !important;\n        width:100%;\n    }\n    .ow-data-table-container {\n        min-height: calc(100vh - 220px) !important;\n        min-height: calc(100dvh - 220px) !important;\n        min-height: calc(100svh - 220px) !important;\n\n    }\n}\n@media only screen and (max-width: 991.98px) {\n    .ow-data-table-container {\n        min-height: calc(100vh - 180px) !important;\n        min-height: calc(100dvh - 180px) !important;\n        min-height: calc(100svh - 180px) !important;\n    }\n  \n}\n@media  (max-width: 767.98px) and (max-height: 950px) {\n    .schema-engine-tabs-content{\n        height: calc(100vh - 250px) !important;\n        height: calc(100dvh - 250px) !important;\n        height: calc(100svh - 250px) !important;\n    }\n}\n  @media only screen and (max-width: 768px) {\n    .table-wrapper {\n        height: calc(100vh - 250px) !important;\n        height: calc(100dvh - 250px) !important;\n        height: calc(100svh - 250px) !important;\n        width:100%;\n    }\n  \n\n    .wrapper {\n        padding-top: 10px;\n       /* background: #FFFFFF 0% 0% no-repeat padding-box;*/\n        box-shadow: 0px 2px 10px #0000001A;\n        margin: 0px 4px;\n        border-radius: 4px;\n    }\n\n    \n    .slide-button {\n      /*  position: absolute; */\n        width: 50px;\n        height: 100%;\n        /* top: 95px;*/\n        background-color: transparent;\n        border:0px solid;\n    }\n\n    .ow-nst-map-left-sliding-panel{\n        position : absolute;\n        width: 100%;\n        height: 90%;\n        top: 0px;\n        left: 0px;\n        display: flex;\n        /* flex-direction : column; */\n        z-index: 999;\n        bottom:0;\n    }\n\n\n    .ow-nst-map-left-sliding-panel   .ow-nst-map-left-sliding-panel-inner{\n        position :relative;\n        top:0;\n        left:0;\n        width: 100%;\n        height:100%;\n        display: flex;\n        flex-direction : column;    \n        background-color: rgb(255, 255, 255);\n        padding-top: 10px;\n    }\n\n    .single-page-header {\n        display:flex;\n        flex-direction: row;\n        max-height: 140px !important;\n    }\n}  \n\n@media only screen and (min-width: 768px) and (max-width: 992px){\n    .table-wrapper {\n        height: calc(100vh - 150px);\n        width:100%;\n    }\n}\n\n.tooltip-inner {\n    text-align: left;\n}\n.tooltip-inner li{\n    list-style: none;\n}\n\n\n.uploadIcon {\n    width: 100px;\n    height: 100px;\n}\n\n.no-link {\n    text-decoration:none;\n}\n\n.fuota-stepper .table-wrapper {\n   /* border: 1px solid !important;\n*/\n    padding : 0 !important;\n  }\n  \n  .fuota-stepper .table-wrapper .single-page-header{\n    display: none !important;\n  }\n\n  .fuota-stepper-device .table-wrapper .single-page-header{\n    display: none !important;\n  }\n  .fuota-stepper-device .table-wrapper {\n    padding : 0 !important;\n  }\n\n  .stepper-main {\n    height: 60px;\n  }\n\n  .stepper-circle {\n    height: 30px !important;\n     width:30px !important;\n        z-index: 9 !important;\n    }\n\n    .border-stepper-black {\n        border: 1px solid black !important;\n    }\n\n  .custom-progress {\n    height: 5px !important;\n    position: relative !important;\n    top: -30% !important;\n    background-color: black !important;\n  }\n\n  .progress-bar {\n    background-color: black !important;\n  }\n  .step-primary {\n    background: #0b0c0d !important;\n    border: 1px solid #0b0c0d !important;\n  }\n.xterm .xterm-screen {\n\nwidth: 1200px !important;\n}\n\n.expose {\n    position:relative;\n}\n\n#overlay {\n    background:rgba(0,0,0,0.3);\n    display:none;\n    width:100%; height:100%;\n    position:absolute; top:0; left:0; z-index:99998;\n}\n\n.badge-map {\n    height: 16px !important;\n    width : 16px !important;\n    border-radius:50% !important;\n    color : white !important;\n    justify-content: center;\n    display: flex;\n    align-items: center;\n    font-size: 75% !important;\n    font-weight : 700 !important;\n  }\n\n  /* \n  .custom-dropdown > .dropdown > button {\n    background: transparent !important;\n    border: none !important;\n    padding: 0 !important;\n    color: #000!important;\n    font-size: .875em !important;\n  }\n  */\n.schema-engine-table-type{\n    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.25);\nborder-radius: 6px;\n}\n\n  .ellipsis-class {\n    white-space: nowrap !important; \n    overflow: hidden !important;\n    text-overflow: ellipsis !important; \n  }\n  .schema-engine-table-type thead tr th {\n    color: rgb(5, 106, 157);\n    background-color: #64badd;\n    border-color: #32383e;\n    border-radius: 0px;\n    padding: 0.2rem 0.4rem !important;\n    font-size: 1rem;\nfont-weight: 600;\n}\n.schema-engine-table-type thead tr{\n    border-top: 0px;\n}\n\n\n\n.schema-engine-table {\n    overflow: auto;\n}\n\n.schema-engine-table-header th {\n    color: #495057;\n    background-color: #e9ecef;\n    border-color: #dee2e6;\n  }\n\n\n\n.schema-engine-table-type thead tr th:first-child{\n    border-top-left-radius: 6px;\n}\n.schema-engine-table-type thead tr th:last-child{\n    border-top-right-radius: 6px;\n}\n.ow-popover{\n    max-width: 200px;\n    box-shadow: 0 .2rem 0.3rem rgba(0, 0, 0, 0.38) !important;\n    padding-bottom: 10px;\n}\n.ow-popover.ow-popover-connection-status{\n    max-width: 400px;\n    padding-bottom: 0px !important;\n}\n.ow-popover.ow-popover-connection-status .ow-popover-status{\n    font-size: small;\n    font-style: italic;\n}\n\n.ow-popover .popover-header{\n    background-color: transparent;\n    font-weight: 600;\n    border-bottom: 0px;\n    padding-left: 0.6rem;\n}\n.ow-popover .popover-body{\n    max-height: 250px;\n    overflow-y: auto;\n}\n\n.schema-engine-help-popover-big{\n    max-width: 800px;\n}\n\n.schema-engine-help-popover{\n    box-shadow: 0 .2rem 0.3rem rgba(0, 0, 0, 0.38) !important;\n}\n\n.schema-engine-help-popover .popover-header{\n    background-color: transparent;\n    border-bottom: 0px !important;\n    font-weight: 600;\n}\n.schema-engine-help-popover .popover-body{\n    padding-top: 0%;\n}\n\n.scroll-btn {\n    position: fixed !important; \n    width: 50px !important;\n    right: 0% !important;\n    bottom: 0% !important;\n    height: 50px !important;\n    font-size: 3rem !important;\n    z-index: 999 !important;\n    cursor: pointer !important;\n    border-radius: 50%;\n    color: #fff !important; \n    background-color: #00000082;\n    margin-right: 10px;\n    text-align: center;\n}\n.scroll-btn svg{\n    font-size: 1.5rem !important;  \n    margin-bottom: 20px;\n}\n\n\n      .card-body .form-switch .form-check-input[type=\"checkbox\"][disabled] {\n        cursor: not-allowed !important;\n        pointer-events : unset !important;\n      }\n\n      .schema-engine-array-accordian-container  {\n        margin-left:20px;\n        counter-reset: item;\n      }\n      \n      .schema-engine-array-accordian-container .schema-engine-array-accordion-element-object {\n          margin:10px 0 10px 0px;\n          border-radius: 5px;\n          position: relative;\n      }\n      .schema-engine-array-accordian-container .schema-engine-array-accordion-element-object:before {\n            content: \"\";\n            counter-increment: item; \n            position: absolute;\n            top:-10px;\n            left:-20px;  \n            border-left: 0.1rem solid #acacac;\n            border-bottom: 0.1rem solid #acacac;\n            width: 20px;\n            height: 40px;\n            border-bottom-left-radius: 12px;\n          }\n          .schema-engine-array-accordian-container .schema-engine-array-accordion-element-object:after {\n            position:absolute;\n            content:\"\";\n            top:20px;\n            left:-20px;  \n            border-left: 0.1rem solid #acacac;\n            border-bottom: 0.1rem solid #acacac;\n            width:0px;\n            height:100%;\n          }\n          .schema-engine-array-accordian-container .schema-engine-array-accordion-element-object:last-child:after {\n            display:none;\n          }\n          .schema-engine-array-accordian-container .schema-engine-array-accordion-element-object h2 {\n            display:block; \n            color:rgba(102,102,102,1);\n            text-decoration:none;\n          }\n          .schema-engine-array-accordian-container .schema-engine-array-accordion-element-object h:before{ \n            content: counters(item, \".\") \" \";    \n          }\n\n\n\n.schema-engine-dropzone,\n.schema-engine-dropzone > div {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-height: 0;\n}          \n.dropzone {\n    min-height: auto;\n    padding: 1.5rem 1.75rem;\n    text-align: center;\n    cursor: pointer;\n    border: 1px dashed #c3c3c3;\n    background-color: #fff;\n    border-radius: .475rem!important;\n}\n\n.dropzone.dz-clickable .dz-message, .dropzone.dz-clickable .dz-message * {\n    cursor: pointer;\n}\n.dropzone .dz-message {\n    margin: 0;\n    display: flex;\n    text-align: left;\n}\n.dropzone .dz-message h3{\n    margin-top: 0px;\n}\n\n.schema-engine-status-list .list-group-item{\n    padding: 0px;\n}\n\n.schema-engine-simple-page {\n    background-color: white;\n    max-height: calc(100vh - 120px) !important;\n    min-height: calc(100vh - 120px) !important;\n  border-radius: 0.5rem ;\n  overflow-y: scroll;\n  padding: 0.5rem;\n  box-shadow: 0 2px 6px 0 rgba(67,89,113,.12);\n\n\n}\n.schema-engine-logs-content .schema-engine-logs-content-empty{\n    text-align: center;\n\n}\n.ow-state  {\n    width: 100%;\n}\n\n.schema-engine-no-breadcrumb-wrapper{\n    max-height: calc(100vh - 80px) !important;\n    position: relative;\n    overflow: scroll;\n}\n.fa-90 {\n    font-size: 0.925em !important;\n}\n.fa-80 {\n    font-size: 0.825em !important;\n}\n.fa-75 {\n    font-size: 0.750em !important;\n}   \n.fa-85 {\n    font-size: 0.850em !important;\n}\n.fa-60 {\n    font-size: 0.60em !important;\n}\n.text-bg-green{\n    background-color: #ddf6d7;\nborder-color: #ddf6d7;\ncolor: #2e8e19;\n}\n\n.text-bg-blue{\n    background-color: #dbecfb !important;\n    border: 1px solid #dbecfb;\n    color: #3172ad;\n}\n.text-bg-red{\n    background-color: #f4d5d5;\n    border: 1px solid #f4d5d5;\n    color: #f13b46;\n}\n.text-bg-darkorange{\n    background-color: #f1dba5;\n    border: 1px solid #f1dba5;\n    color: #b97f2b;\n}\n.text-bg-yellow{\n    background-color: #f0dba6 !important;\n    border:1px solid #cfad58;\n    color: #aa872c;\n}\n\n.livelog-date {\n\n    background-color: #dff0d8; \n    border-color: #d6e9c6;\n    color: #3c763d;\n    padding: 4px 6px;\n    font-size: 0.9em;\n}\n\n.livelog-event {    \n\n    background-color: #dff0d8;\n    border-color: #d6e9c6;\n    color: #3c763d;\n    padding: 4px 6px;\n    font-size: 0.9em;\n}\n.livelog-lamdha {\n\n    background-color: #f2e4c1;\n    border-color: #f2cf82;\n    color: #e49626;\n    font-size: 0.9em;\n    padding: 4px 6px;\n}\n.livelog-deviceUuid {\n\n    background-color: #D0F6FF;\n    border-color: #A3E7FF;\n    color: #076d9f;\n    font-size: 0.9em;\n    padding: 4px 6px;\n}\n.livelog-connectionUuid {\n    background-color: #D0F6FF;\n    border-color: #A3E7FF;\n    color: #076d9f;\n    font-size: 0.9em;\n    padding: 4px 6px;\n}\n\n.livelog-error {\n    background-color: rgb(247, 184, 184);\n    color: rgb(163, 59, 59);\n    font-size: 0.9em;\n    border-color: rgb(247, 184, 184);\n    padding: 4px 6px;\n}\n\n.log-search-bar {\n    width: 100%;\n    padding: 4px 10px;\n    margin-bottom: 5px;\n    box-sizing: border-box;\n    border: 1px solid #dee2e6;\n    border-radius: 0.25rem;\n}\n\n.health-badge-suspended {\n    background-color: rgb(247, 184, 184);\n    color: rgb(163, 59, 59);\n    font-size: 0.7em;\n    border-color: rgb(247, 184, 184);\n    padding: 4px 6px;\n}\n\n\n\n/* Map Pop Up Class*/\n\n.max-three-lines {\n    max-height: calc(3 * 1.2em); \n    overflow-y: auto; /* Change from hidden to auto for vertical scrolling */\n    display: -webkit-box;\n    -webkit-line-clamp: 3; /* Number of lines to display */\n    -webkit-box-orient: vertical;\n    white-space: normal;\n    margin-left: 3.5px;\n    word-wrap: break-word;\n}\n\n\n.opearational-status-light-gray {\n    color: #d3d3d3;\n}\n\n.opearational-status-dark-gray {\n    color: #666;\n}\n\n.opearational-status-yellow {\n    color: #E4A11B\n}\n\n.opearational-status-green {\n    color: #038838;\n}\n\n.opearational-status-light-green {\n    color: rgb(199, 251, 199);\n}\n\n.opearational-status-red {\n    color: #ff0000;\n}\n\n.opearational-status-dark-red {\n    color: #8b0000;\n}\n\n.bulk_action_checkbox .form-check-input {\n    border-color: #8e8b8b;\n}\n\n[class*=\"ValueContainer\"] [class*=\"placeholder\"] {\n    /* styles */\n    font-size: .875rem;\n    color: #d4d4d4;\n  }\n\n\n.breadcrumb-dropdown-menu {\n    max-height: 400px;\n    overflow-y: scroll;\n}\n\n/*-----------------------------------------------------------------------*/\n/*----------------------- Dashboard grid-stack cards style start ------------------------*/\n/*-----------------------------------------------------------------------*/\n\n.grid-stack-item{\n\n}\n\n/*-----------------------------------------------------------------------*/\n/*----------------------- Dashboard grid-stack cards style end ------------------------*/\n/*-----------------------------------------------------------------------*/\n\n\n/*----------------------------------redoc style-------------------------------------*/\n.redoc-wrap .menu-content {\n    height: calc(100vh - 130px) !important;\n}\n\n.redoc-wrap .menu-content  .sc-gfopwy {\n    display: none;\n}\n\n\n/*-------------------swagger page style-------------------------*/\n.swagger-ui .info {\n    margin: 10px 0 !important;\n}\n.swagger-ui .scheme-container {\n    background: transparent !important;\n    box-shadow: none !important;\n    margin: 0 0 0px !important;\n    padding: 0px 0 !important;\n}\n\n\n\n\n.alert {\n    font-size: 0.6rem !important;\n    padding: 0.5rem;\n}\n\n.alert .alert-heading.h4 {\n    font-size: 0.8rem !important;\n}\n.alert-danger .alert-heading {\n    color: #ce0008;\n}\n.alert-danger{\n    background-color: #fffbfc !important;\n    border-color: #f1152c !important;\n}\n.leaflet-top, .leaflet-bottom{\n    \n    z-index: 999 !important;\n}\n.form-label {\n    margin-bottom: .1rem;\n}\n\n.selected-radio {\n    background-color: #e0e0e0; /* Dark gray background */\n    color: #000; /* Text color for contrast */\n    border-radius: 4px; /* Rounded corners for aesthetics */\n}\n\n.selected-radio .form-check-input:checked {\n    background-color: #000; \n    border-color: #000 ;\n}\n\n\n/* Apply styles to the menu */\n.custom-select-menu {\n    background-color: #fff !important;\n    z-index: 9999 !important;\n    min-width: 250px;\n  }\n  \n  /* Style options */\n  .custom-select-option {\n    background-color: #fff !important;\n    color: #000 !important;\n  }\n  \n  /* Style for selected option */\n  .custom-select-option--selected {\n    background-color: #000 !important;\n    color: #fff !important;\n  }\n  \n  /* Style for focused/hovered option */\n  .custom-select-option--focused {\n    background-color: #afafaf !important;\n  }\n\n\n  /* Tag list styling */\n.tag-list {\n    list-style-type: none;\n    margin-bottom: 0;\n    padding-left: 0;\n}\n  \n.tag-list-item {\n    padding: 3px 6px;\n    margin: 2px 0;\n    border-radius: 3px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.abort-btn {\n  display: inline-flex;\n  align-items: center;\n  margin-left: 5px;\n  gap: 6px;               /* space between icon and text */\n  height: 28px;\n  padding: 0 10px;\n  background-color: var(--bs-btn-bg, #212529);        /* use BS variable */\n  color: var(--bs-btn-color, white);         /* fallback to white if not defined */\n  border: none;\n  border-radius: var(--bs-btn-border-radius, 4px); /* optional: use BS border-radius variable */\n  font-size: 13px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n/* hover state using BS variable if available */\n.abort-btn:hover {\n  background-color: var(--bs-btn-hover-bg, #424649);\n  color: var(--bs-btn-hover-color, #fff);\n}\n\n/* active state using BS variable if available */\n.abort-btn:active {\n  background-color: var(--bs-btn-active-bg, #111);\n  color: var(--bs-btn-active-color, #fff);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
